"use strict";

angular.module("PatientApp").config(["$translateProvider", function ($translateProvider) {
  $translateProvider.translations("en", {
    "dashboard": {
      "dashboard": "Providers",
      "home": "Home",
      "failedToLoadProvider": {
        "header": "Error: Unable to Load",
        "body": "An error occurred while trying to load more information for this provider. Please try again.",
        "button": "Back"
      },
      "zeroStateTitle": "No Providers",
      "zeroStateBlurb": "Enter the details of your most recent bill to access up-to-date balances, past billing activity, and transaction details across your healthcare providers.",
      "zeroStateTitleMyChartSSO": "No Bills",
      "zeroStateBlurbMyChartSSO": "There aren't any bills available for you at this time.",
      "argsDashboard": "{{name}}'s Providers",
      "argsDashboardEndsWithS": "{{name}}' Providers",
      "possessivePatientWallet": "{{name}}'s PatientWallet",
      "possessivePatientWalletEndsWithS": "{{name}}' PatientWallet",
      "yourPatientWallet": "Your PatientWallet"
    },
    "encounterLinking": {
      "linkableAccounts": "We've found additional accounts to add to your PatientWallet<sup>&reg;</sup>. <a href=\"\" class=\"link inline\" >Verify Accounts</a>",
      "proactiveLinkableAccounts": "Want us to automatically add accounts for {{providerGroupList}} to your PatientWallet<sup>&reg;</sup>? <a href=\"\" class=\"link inline\">Verify Accounts</a>",
      "experiencedLinkableAccounts": "You have more accounts to add to your PatientWallet<sup>&reg;</sup>. <a href=\"\" class=\"link inline\" >Verify Accounts</a>",
      "verifyInformation": "Verify Information",
      "verifyingInformation": "Verifying Information...",
      "whichPatient": "Who would you like to verify?",
      "verifyAcctTitle": "Verify Information For<br /> {{linkingName}}",
      "verifyAcctSubtitlePatient": "Enter the security fields below to add {{patientName}} accounts from {{providerGroup}}.",
      "verifyAcctSubtitleGuarantor": "Enter your information below to add {{patientName}} accounts from {{providerGroup}}.",
      "birthdatePlaceholder": "Date of Birth (MM/DD/YYYY)",
      "SSNPlaceholder": "Last Four Digits of Social Security Number",
      "ssnHelpInfo": "<b>Note:</b> If you're adding accounts for an infant, use the guarantor's SSN",
      "moreInfo": "How does this work?",
      "verificationFailed": "The information you've entered does not match our records for {{patientName}}. Please try again.",
      "verificationBlocked": "You have attempted to add {{patientName}} account too many times.  For security reasons, your ability to add this account has been disabled temporarily.",
      "verificationHeader": "Account successfully added.",
      "verificationHeaderPlural": "Accounts successfully added.",
      "verificationSubheader": "In the future, we'll automatically add {{patientName}} bills for {{providerGroup}} to your PatientWallet<sup>&reg;</sup>.",
      "proactiveExperiencedVerificationSubheader": "{{patientName}} doesn't have any past accounts to add, but we'll automatically add their future bills for {{providerGroup}} to your PatientWallet<sup>&reg;</sup>.",
      "incompleteSSN": "Looks like you're missing a few digits. Please enter the last four numbers of your SSN.",
      "proactiveVerificationHeader": "{{patientName}} successfully verified.",
      "close": "Close",
      "continueToPay": "Continue to Bill"
    },
    "firstComm": {
      "optionsHeader": "Verify Information",
      "verifyEmailHeader": "Check your email!",
      "verifySmsHeader": "Check your phone!",
      "birthdatePlaceholder": "Date of Birth (MM/DD/YYYY)",
      "SSNPlaceholder": "Last Four Digits of Social Security Number",
      "incompleteSSN": "Looks like you're missing a few digits. Please enter the last four numbers of your SSN.",
      "verifyViaEmailOption": "Email me a code ({{emailAddress}})",
      "verifyViaSmsOption": "Text me a code ({{phoneNumber}})",
      "verifyViaPdiv": "Enter your demographics",
      "sendAgainButtonText": "I didn't receive a code",
      "sendingCodeButtonText": "Sending...",
      "back": "Back",
      "submitText": "Next",
      "submittingText": "Checking...",
      "successHeader": "You have been verified!",
      "codeNotSent": "There was a problem sending that code. Please try again.",
      "codeSent": "Code has been sent.",
      "codeInvalid": "That code was invalid or expired. Please try again.",
      "pdivInvalid": "One or more fields did not match our records.  If you believe your information is correct, please contact your provider.",
      "bruteForce": "Account temporarily disabled due to too many failed attempts.",
      "missingGuarantorName": "Patient"
    },
    "firstBill": {
      "optionsSubheader": "{{providerName}} needs to verify your identity before you can access your bill.",
      "verifyEmailSubheader": "Please enter the code we sent to your email address ({{emailAddress}}) to access your bill from {{providerName}}.",
      "verifySmsSubheader": "Please enter the code we sent to your mobile device via text message ({{phoneNumber}}) to access your bill from {{providerName}}.",
      "verifyPdivHeader": "Enter the security fields below to access your bill from {{providerName}}",
      "successSubheader": "Click below to see your bill.",
      "successModalButton": "View Bill",
      "unableToAuth": "We are unable to authenticate your account at this time.  Your bill should arrive in the mail soon."
    },
    "firstEstimate": {
      "optionsSubheader": "{{providerName}} needs to verify your identity before you can access your estimate.",
      "verifyEmailSubheader": "Please enter the code we sent to your email address ({{emailAddress}}) to access your estimate from {{providerName}}.",
      "verifySmsSubheader": "Please enter the code we sent to your mobile device via text message ({{phoneNumber}}) to access your estimate from {{providerName}}.",
      "verifyPdivHeader": "Enter the security fields below to access your estimate from {{providerName}}",
      "successSubheader": "Click below to see your estimate.",
      "successModalButton": "View Estimate",
      "unableToAuth": "We are unable to authenticate your account at this time.  Your estimate should arrive in the mail soon."
    },
    "confirmPhone": {
      "header": "Complete Account Registration",
      "numberSubheader": "Please verify your mobile phone number.",
      "codeSubheader": "Please enter the code we sent to your mobile device via SMS.",
      "submitButtonText": "Send Code",
      "submittingButtonText": "Sending...",
      "verifyButtonText": "Verify",
      "verifyingButtonText": "Verifying...",
      "sendAgainButtonText": "I didn't receive a code",
      "successHeader": "Thank you for verifying your phone number.",
      "learnMore": "Learn More",
      "hide": "Hide",
      "additionalInfo": "By verifying your phone number, you agree to allow Patientco to send you periodic text messages for any account-related activity. Patientco may use an automated system to send you electronic communications including text, phone, or email. Patientco does not have a separate charge for this service; however, subject to the terms and conditions of your mobile carrier, message and data rates may apply. By providing your consent to participate in this program, you approve any such charges from your mobile carrier. You may opt out of this program at any time by emailing Patientco at support@patientco.com.",
      "explanation": "Patientco will send you a text message with a unique code to verify your mobile phone number.",
      "errors": {
        "sentAgain": "Sorry about that! We sent you another code.",
        "codeNotSent": "There was a problem sending that code. Please try again.",
        "codeInvalid": "That code was invalid or expired. Please try again."
      }
    },
    "confirmEmail": {
      "header": "Verify Email Address",
      "submitButtonText": "Send Email",
      "submittingButtonText": "Sending...",
      "explanation": "Is the email address listed correct? If not, please correct it above prior to clicking the \"Send Email\" button to update your account.",
      "successHeader": "Verification email sent.",
      "emailNotSent": "There was a problem sending that email. Please try again."
    },
    "receipt": {
      "receipt": "Receipt",
      "argPaidCallout": "<b>{{amount}}</b> Paid",
      "argScheduledCallOut": "<b>{{amount}}</b> Scheduled",
      "argAuthorizedCallOut": "<b>{{amount}}</b> Authorized",
      "argRemainingCallOut": "<b>{{amount}}</b> Remaining",
      "transactionIdArg": "Transaction ID # {{transactionId}}",
      "balancePayment": "Balance Payment",
      "argDeclinedCallout": "<b>{{amount}}</b> Declined",
      "argCanceledCallout": "<b>{{amount}}</b> Canceled",
      "confirmCancelDialog": "Are you sure you want<br />to cancel this payment?",
      "cancelPaymentDesc": "{{amount}} scheduled for {{date}}",
      "fullRefund": "Full Refund",
      "partialRefund": "Partial Refund",
      "chargeback": "Chargeback",
      "failedECheck": "Failed eCheck",
      "bouncedCheck": "Bounced Check",
      "paymentMethodUpdated": "Payment method has been updated.",
      "paymentMethodHeld": "We were unable to process a payment.  Please select another payment method and try again.",
      "updateMethodScheduledPlanConfirmDialog": "The remaining payments in your plan will be updated to use {{method}}.",
      "updateMethodHeldPlanConfirmDialog": "The remaining payments in your plan will be updated to use {{method}}.<br/><br/>Any payments in the plan that were previously declined or held will be processed using the new payment method.",
      "printingNotSupportedHeader": "Printing not available",
      "printingNotSupportedContent": "We were unable to activate the print feature of your browser. If your browser supports printing, please try using the built-in print action. Otherwise, click {{viewBill}} to download a PDF of your bill.",
      "paidWithApplePayDesc": "Paid with Apple Pay",
      "billTo": "Bill To:",
      "methodChanged": "Payment method changed."
    },
    "newbill": {
      "whichAccount": "Which bill would you like to pay?",
      "accountDue": "<b>{{providerName}}</b><br/>Account #{{accountNumber}} | {{amountDue}} due",
      "accountPastDue": "<b>{{providerName}}</b><br/>Account #{{accountNumber}} | {{amountDue}} past due"
    },
    "planReceipt": {
      "paymentPlanUpdated": "Payment Plan Updated",
      "paymentPlanCreated": "Payment Plan Created",
      "printingNotSupportedHeader": "Printing not available",
      "printingNotSupportedContent": "We were unable to activate the print feature of your browser. If your browser supports printing, please try using the built-in print action. Otherwise, click {{viewBill}} to view your payment plan receipt.",
      "messageProviderForQuestions": "Please contact your provider if you have any questions or if you'd like to make any changes to your payment plan."
    },
    "message": {
      "message": "Message",
      "plural": "Messages",
      "newMessage": "New Message",
      "messageSent": "Your message has been sent!",
      "argsMessages": "{{name}}'s Messages",
      "argsMessagesEndsWithS": "{{name}}' Messages",
      "createAreaPlaceholder": "Start typing your reply...",
      "whoToContact": "Who would you like to contact?",
      "whichAccount": "Which account do you need help with?",
      "noProvidersToMessage": "Your PatientWallet<sup>&reg;</sup> is currently empty. Please add a new bill to get started.",
      "startMessagePlaceholder": "Start typing your message...",
      "messageClosedByProviderDialog": "This message thread is closed.",
      "startNewMessageDialog": "If you'd like to start another message thread, ",
      "clickHereWithPeriod": "click here.",
      "argProviderCantMessage": "{{name}} does not support messaging through Patientco. If you would like to contact your provider, please call {{billingPhoneNumber}}. We apologize for any inconvenience.",
      "reasons": {
        "default": "Select a Reason",
        "specificCharge": "Question a Specific Charge",
        "duplicate": "Question Duplicate Charges/Bill",
        "paymentPlan": "Set up a Payment Plan",
        "missingPayments": "Inquire About Missing Payments",
        "other": "Other",
        "updateInsurance": "Update Information",
        "insuranceQuestion": "Ask an Insurance Question",
        "financialAssistance": "Inquire About Financial Assistance",
        "itemizedBill": "Request an Itemized Bill",
        "estimate": "Question About Estimate"
      },
      "zeroStateTitle": "No Messages",
      "zeroStateBlurb": "Securely communicate with all of your healthcare providers in one place. Ask a question about your bill, set up a payment plan, or just say thanks!",
      "reason": "Reason",
      "provider": "Provider",
      "selectProvider": "Select a Provider",
      "account": "Account",
      "selectAccount": "Select an Account",
      "messagingDisabled": "Messaging is disabled for your provider.",
      "messagingDisabledPhoneNumber": "Please contact them at "
    },
    "notification": {
      "notification": "Notification",
      "plural": "Notifications",
      "zeroStateTitle": "No Notifications",
      "noLongerAvailable": "This notification is no longer available."
    },
    "login": {
      "minCharactersRule": "8 characters",
      "upperCaseRule": "1 uppercase letter",
      "digitRule": "1 number",
      "nextButton": "Next",
      "forgotPasswordQuestion": "Forgot your password?",
      "forgotPasswordQuestionSubcontent": "We've got you covered.",
      "forgotPasswordSentDialog": "Great! We've sent help to<br /><b>{{email}}</b>",
      "forgotPasswordMethodHeader": "How would you like to reset your password?",
      "forgotPasswordMethodEmailButton": "Email me ({{email}})",
      "forgotPasswordMethodSmsButton": "Text me ({{phone}})",
      "forgotPasswordMethodCode": "Please enter your verification code.",
      "forgotPasswordCheckEmailTitle": "Check your email and click the link.",
      "forgotPasswordEmailSentTryAgainButton": "Try Again",
      "forgotPasswordMethodSendAgainButton": "I didn't receive a code",
      "resetPasswordHeader": "Create your new password.",
      "resetPasswordCompleteDialog": "You may now log in using your email and new password.",
      "resetPasswordCheckEmailMessage": "We just sent an email containing a password reset link to<br /><b>{{email}}</b>.<br /><br />If you don't see it in your inbox, be sure to check your spam folder."
    },
    "setting": {
      "menu": {
        "contact": "Contact Information",
        "savedPaymentMethods": "Saved Payment Methods",
        "accountManagement": "Account Management"
      },
      "setting": "Setting",
      "plural": "Settings",
      "argsSettings": "{{name}}'s Settings",
      "argsSettingsEndsWithS": "{{name}}' Settings",
      "ebillDialog": "Email me when new bills are added to my account.",
      "smsDialog": "Text me when new bills are added to my account.",
      "argMethodDeleted": "{{method}}<br />has been deleted",
      "deleteMethodArg": "Delete {{detail}}",
      "confirmDeleteDialog": "Are you sure you want to delete this payment&nbsp;method?",
      "passwordChangedDialog": "Your password has been changed successfully.",
      "unremovableMethodHelp": "This payment method is being used to make a <br />scheduled payment and cannot be deleted.",
      "nonDeactivateableUserHelp": "You cannot deactivate your account because<br/> you have one or more scheduled payment(s).",
      "modals": {
        "email": {
          "header": "Email Communications",
          "content": "By enabling email notifications, you are giving Patientco permission to periodically email you new bills or reminders about bills with pending due dates. Email notification is an optional feature of Patientco that is disabled until you modify your notification settings in the “Settings” tab or on the registration page. You may choose to enable or disable this feature at any time, but changes may take up to 48 hours to become effective. Patientco reserves the right to discontinue eBill notifications at any time, in our sole discretion. Your Protected Health Information (PHI) will not be contained in any emails. Your PHI can only be viewed by logging into Patientco using your registered email address."
        },
        "sms": {
          "header": "SMS Communications",
          "content": "By enabling text message notifications, you agree to allow Patientco to send you periodic text messages for any account-related activity. Patientco may use an automated system to send you electronic communications including text, phone, or email. Patientco does not have a separate charge for this service; however, subject to the terms and conditions of your mobile carrier, message and data rates may apply. By providing your consent to participate in this program, you approve any such charges from your mobile carrier. You may opt out of this program at any time in the \"Settings\" tab in your PatientWallet<sup>&reg;</sup>."
        }
      },
      "methodAdded": "{{method}}<br/>has been added"
    },
    "landing": {
      "title": "Patientco | Pay Your Bill",
      "enterBills": "Enter the unique details from your bill.",
      "marketingBlurb": "Welcome to the PatientWallet<sup>&reg;</sup>! We’ve partnered with your healthcare provider to give you the simplest, most secure payment experience possible.",
      "needHelpHeader": "Need help finding your bill?",
      "needHelpContent": "Click into the white boxes provided to enter your SecureHealthCode and Balance Due."
    },
    "providersDashboard": {
      "totalAmountDue": "Total Amount Due",
      "account": "Account",
      "accounts": "Accounts",
      "pastDue": "Past Due",
      "noBills": "No Bills",
      "noBillsDescriptionShort": "When you receive new bills they will appear here.",
      "noBillsDescriptionLong": "When you receive new bills they will appear here. If you have received a bill and you don't see it listed, <a @click=\"findBillBottomSheet = true\" class=\"find-bill-bottom-sheet-link\"><u>click here</u></a> to search for your bill."
    },
    "accountsSummaryAccountCard": {
      "accountNumber": "Account #...",
      "dueBy": "Due by",
      "bill": "Bill",
      "bills": "Bills",
      "estimate": "Estimate",
      "estimates": "Estimates"
    },
    "dbuUpdate": {
      "lastStatementBalance": "Last Statement Balance",
      "balanceIncrease": "Balance Increase",
      "balanceDecrease": "Balance Decrease",
      "bottomSheetHeaderIncrease": "Your account balance has increased since your last statement.",
      "bottomSheetHeaderDecrease": "Your account balance has decreased since your last statement.",
      "bottomSheetBody": "Since your last statement there has been new activity on your account. In most cases the updated balance reflects new charges, payments, or insurance contributions."
    },
    "contact": {
      "help": {
        "header": "I need help with:",
        "myBill": "Understanding my bill",
        "lostBill": "I lost my Patientco bill",
        "loggingIn": "Logging in",
        "itemizedBill": "I need an itemized bill",
        "resetPassword": "Reset my password"
      },
      "questionAbout": {
        "header": "I have a question about:",
        "reasons": {
          "specificCharge": "A charge on my bill",
          "duplicate": "A duplicate charge or bill",
          "paymentPlan": "Creating a payment plan",
          "missingPayments": "Missing payments",
          "other": "Other",
          "updateInsurance": "Updating Information",
          "insuranceQuestion": "Insurance",
          "financialAssistance": "Financial assistance",
          "itemizedBill": "Requesting an itemized bill",
          "estimate": "Estimate"
        }
      },
      "rightPlace": {
        "header": "Let's get you to the right place.",
        "enterEmail": "Please enter your email address:",
        "enterBillDetails": "Please enter your bill details:"
      },
      "almostThere": {
        "header": "Almost there...",
        "password": "Please create a password:",
        "login": "Please log in to your account:"
      }
    },
    "chat": {
      "paymentPlans": {
        "selectProvider": "Please select a provider to see eligible accounts:",
        "selectAccount": "Please select an account to see available plan options:",
        "noProviders": "Your PatientWallet is currently empty. Please add a new bill to see available plan options."
      }
    },
    "actions": {
      "pay": "Pay",
      "makePayment": "Make A Payment",
      "viewPaymentOptions": "View Payment Options",
      "payThisVisit": "Pay This Visit",
      "viewEstimateDetails": "View Estimate Details",
      "viewMyBill": "View Bill",
      "viewBill": "View Bill",
      "viewLastStatement": "View Last Statement",
      "viewPlan": "View Plan",
      "viewAccounts": "View Accounts",
      "viewAccount": "View Account",
      "viewMessage": "View Message",
      "viewEstimate": "View Estimate",
      "viewDashboard": "View Dashboard",
      "view": "View",
      "edit": "Edit",
      "verify": "Verify",
      "verifying": "Verifying...",
      "submit": "Submit",
      "submitting": "Submitting...",
      "messageProvider": "Message Provider",
      "updatePaymentForm": "Change Payment Method",
      "createMessage": "Create New Message",
      "continue": "Continue",
      "continueSingle": "Make a One Time Payment",
      "continuePlan": "Create a Payment Plan",
      "setUpAutoPayPlan": "Set Up an Auto Pay Plan",
      "mergePlan": "Update Payment Plan",
      "processPayment": "Process Payment",
      "retryProcessPayment": "Retry Process",
      "processPaymentFuture": "Schedule Payment",
      "createAccount": "Create Account",
      "creatingAccount": "Creating Account...",
      "login": "Log In",
      "loggingIn": "Logging In...",
      "logout": "Log Out",
      "payNewBill": "Pay New Bill",
      "payBill": "Pay Bill",
      "goToVendor": "Go to {{financedBy}}",
      "payAsGuest": "Pay As Guest",
      "sendingToGuestPay": "Sending To Guest Pay...",
      "payAnotherBill": "Pay Another Bill",
      "openReceipt": "View Receipt",
      "findBill": "Find Bill",
      "findingBill": "Finding Bill...",
      "needHelp": "Need help?",
      "contactUs": "Contact Us",
      "learnMore": "Learn More",
      "goToDashboard": "View Dashboard",
      "open": "Open",
      "sendMessage": "Send Message",
      "send": "SEND",
      "sending": "Sending Message...",
      "attachFile": "Attach File",
      "printReceipt": "Print Receipt",
      "printPlan": "Print Plan Details",
      "back": "Back",
      "backToSSO": "Back to {{ friendlySSOEnvName }}",
      "backToDashboard": "Back to Providers",
      "backToMessages": "Back to Messages",
      "backToArg": "Back to {{properNoun}}",
      "deleteCard": "Delete Card",
      "deleteECheck": "Delete eCheck",
      "addNewMethod": "Add New Method",
      "changePassword": "Change Password",
      "deactivateAccount": "Deactivate Account",
      "confirmPassword": "Confirm Password",
      "close": "Close",
      "cancel": "Cancel",
      "saveChanges": "Save Changes",
      "forgotPassword": "Forgot Your Password?",
      "retrievingResetOptions": "Retrieving Reset Options...",
      "retrievePassword": "Retrieve Password",
      "resetPassword": "Reset Password",
      "visitWebsite": "Visit Website",
      "cancelPayment": "Cancel Payment",
      "viewOlderActivity": "View Older Activity",
      "stayLoggedIn": "Stay Logged In",
      "sendFeedback": "Send Feedback",
      "sendingFeedback": "Sending...",
      "viewZeroBalanceAccts": "View {{count}} Paid Accounts",
      "enterSHCTooltip": "Please enter the SecureHealthCode that is printed on your bill",
      "enterAmountTooltip": "Please enter the Total Balance Due that is printed on your bill, even if you intend to actually pay a different amount",
      "confirmPhoneNumber": "Please verify your mobile phone number.",
      "confirmPhoneNumberNew": {
        "message": "Finish setting up your PatientWallet by <a>verifying your mobile phone number</a>."
      },
      "confirmEmail": "Click here to verify your email address: {{email}}",
      "confirmEmailnew": {
        "message": "Finish setting up your PatientWallet by <a>verifying your email address</a>."
      },
      "verifyFoundAccounts": {
        "message": "We found other accounts that may belong to you. <a>Verify they’re yours to add them to your PatientWallet</a>."
      },
      "processPaymentForm": "Save Payment Method",
      "retryProcessPaymentForm": "Retry Payment Method",
      "confirmAndProcess": "Confirm & Process",
      "accept": "Accept",
      "switchLanguage": "Cambiar a Español",
      "viewPlanDetails": "View Plan Details",
      "resend": "Resend",
      "viewStatmentPDF": "View statement PDF",
      "watchStatementOverview": "Watch statement overview",
      "change": "Change",
      "addPaymentMethod": "Add Payment Method"
    },
    "statusChips": {
      "providerInactive": "Provider Inactive",
      "badDebt": "External Agency",
      "pending": "Pending",
      "dueDate": "Due By {{ date }}",
      "paymentPlanInProgress": "Payment Plan",
      "paymentPlanHeld": "Payment Plan Held",
      "negativeBalance": "Refund Eligible",
      "pastDue": "Past Due",
      "void": "Void"
    },
    "accountStatusSheets": {
      "badDebtHeader": "External Agency",
      "badDebtBody": "Your provider is no longer accepting payments through the PatientWallet because your account is now being managed by a different company. Most often this is because a balance has gone unpaid for an extended period of time. Contact your provider's billing office for instructions on what to do next.",
      "refundEligibleHeader": "Refund Eligible",
      "refundEligibleBody": "In most cases this means you have paid more than what you owe. Contact your provider's billing office for instructions on how to initiate a refund.",
      "providerInactiveHeader": "Inactive Provider",
      "providerInactiveBody": "Your provider is no longer accepting payments through the PatientWallet. Contact your provider's billing office for instructions on how to make payments toward this account."
    },
    "labels": {
      "providerName": "Provider Name",
      "providerLocation": "Provider Location",
      "argAccount": "{{num}}&nbsp;Account",
      "argAccounts": "{{num}}&nbsp;Accounts",
      "argNumPastDue": "{{num}}&nbsp;Past&nbsp;Due",
      "argNumAccountsPastDue": "{{num}}&nbsp;Accounts&nbsp;Past&nbsp;Due",
      "argNumAccountPastDue": "{{num}}&nbsp;Account&nbsp;Past&nbsp;Due",
      "accountNumber": "Account Number",
      "accountNumberConfirm": "Confirm Account Number",
      "guarantorName": "Guarantor Name",
      "name": "Name",
      "firstName": "First Name",
      "lastName": "Last Name",
      "email": "Email Address",
      "phone": "Phone Number",
      "password": "Password",
      "passwordConfirm": "Confirm Password",
      "statementSent": "Bill Date",
      "balancDue": "Due Date",
      "dueDate": "Due Date",
      "dueArg": "Due {{date}}",
      "argDue": "{{amount | currency}} due",
      "pastDue": "Past Due",
      "billSummary": "Bill Summary",
      "costBreakdown": "Cost Breakdown",
      "nameOnCard": "Name on Card",
      "cardNumber": "Card Number",
      "cvvFormat": "CVV",
      "cardExpirationDate": "Expiration date (MM/YY)",
      "expirationFormat": "MM / YY",
      "routingNumber": "Routing Number",
      "accountHolderName": "Account Holder's Name",
      "accountNumberArg": "Account # {{number}}",
      "address": "Address",
      "address2": "Address Line 2 (optional)",
      "city": "City",
      "state": "State",
      "zip": "Zip Code",
      "date": "Date",
      "status": "Status",
      "description": "Description",
      "amount": "Amount",
      "secureCodeOnBill": "SecureHealthCode on Bill",
      "balanceOnBill": "Total Balance Due on Bill",
      "secureCode": "SecureHealthCode",
      "totalBalanceDue": "Total Balance Due",
      "argBalance": "{{balance}} Balance",
      "enterUniqueDetails": "Enter details from your new bill.",
      "badDebt": "Referred to external agency",
      "servicedByFinancingVendor": "Serviced by {{financedBy}}",
      "noBalance": "No Balance Due",
      "pendingBalance": "Pending",
      "remainingBalance": "Balance Remaining",
      "negativeBalance": "Contact your provider for information about your negative balance.",
      "yourBillAmount": "Bill Amount",
      "billAmount": "Bill Amount",
      "billDetails": "Bill Details",
      "newBalance": "Current Balance",
      "updating": "Updating...",
      "loading": "Loading...",
      "noAccountActivity": "No account activity.",
      "accountDetailsActivityHeader": "Activity",
      "contactProvider": "Provider Contact",
      "providerResources": "Provider Resources",
      "needHelp": "Need Help?",
      "providerAccounts": "{{providerName}} Accounts",
      "messageDetails": "Message Details",
      "argPaid": "{{amount}} Paid",
      "argScheduled": "{{amount}} Scheduled",
      "argAuthorized": "{{amount}} Authorized",
      "argTotal": "{{amount}} Total",
      "amountPaid": "Amount Paid",
      "amountAuthorized": "Amount Authorized",
      "details": "Details",
      "userDetails": "User Details",
      "futurePayment": "Future Payment",
      "createdArg": "Created {{date}}",
      "updatedArg": "Updated {{date}}",
      "communicationPrefs": "Communication Preferences",
      "accountManagement": "Account Management",
      "savedMethods": "Saved Payment Methods",
      "financingMethods": "Financing Accounts",
      "noSavedMethods": "Saved payment methods will appear here.",
      "noFinancingMethods": "There are currently no financing accounts. Check with your provider to see if financing is available.",
      "phoneNumber": "Mobile Phone",
      "primaryPhone": "Primary Phone",
      "currentPassword": "Current Password",
      "newPassword": "New Password",
      "confirmNewPassword": "Confirm New Password",
      "submittingPayment": "Processing Payment...",
      "submittingPaymentForm": "Saving...",
      "retrievingPassword": "Retrieving Password...",
      "submittingPaymentFuture": "Scheduling Payment...",
      "resettingPassword": "Resetting Password...",
      "savingChanges": "Saving Changes...",
      "acceptanceOfTerms": "I agree to the <a href=\"https://www.waystar.com/patientco-terms-of-use/\" target=\"_blank\">Terms of Use</a>",
      "changesSaved": "Changes Saved",
      "changesFailed": "Unable to save changes",
      "declinedPayment": "Declined Payment",
      "paymentDeclined": "Payment Declined",
      "argDeclined": "{{amount}} Declined",
      "canceledPayment": "Canceled Payment",
      "paymentCanceled": "Payment Canceled",
      "argCanceled": "{{amount}} Canceled",
      "providerDisabledExplanation": "{{provider.name}} is no longer accepting payments on this account. Click below to view previous payments/receipts.",
      "paymentPlanTitle": "Plan Details",
      "paymentPlanStatus": "Payment Plan {{status}}",
      "verificationCode": "Verification Code",
      "receivesEbills": "Email me new bills & reminders",
      "receivesSms": "Text me new bills & reminders",
      "socialSecurityNumber": "Social Security Number",
      "birthdate": "Date of Birth (MM/DD/YYYY)",
      "income": "Monthly Household Income",
      "changePassword": "Do you need to change your password?",
      "deactivateAccount": "Do you need to deactivate your account?",
      "invalidPassword": "Invalid password",
      "moreInfo": "More Info",
      "appointmentInfo": "Appointment",
      "appointmentSummary": "Appointment Summary",
      "appointmentDate": "Appointment Date",
      "appointmentTime": "Appointment Time",
      "estimate": "Estimate for service on {{date}}",
      "estimateAmount": "Estimate Amount",
      "estimatedVisitCost": "Your Estimated Cost",
      "estimateSummaryServiceAmount": "Estimated Total Cost",
      "estimateSummaryInsuranceCoverage": "Estimated Insurance Coverage",
      "estimateSummaryEstimatedCost": "Your Estimated Cost",
      "estimateSummaryDisclaimerHeader": "Disclaimer:",
      "estimateSummaryDisclaimer": "The numbers above are estimated amounts and are subject to change.",
      "estimateSummaryDisclaimerDetails": "<p>This Good Faith Estimate shows the costs of items and services that are reasonably expected for your health care needs for an item or service. The estimate is based on information known at the time the estimate was created and does not include any unknown or unexpected costs that may arise during treatment. You could be charged more, or receive additional bills, if complications or special circumstances occur. If this happens, federal law allows you to dispute (appeal) the bill.</p><p>If you are billed for more than this Good Faith Estimate, you have the right to dispute the bill.</p><p>You may contact the health care provider or facility listed to let them know the billed charges are higher than the Good Faith Estimate. You can ask them to update the bill to match the Good Faith Estimate, ask to negotiate the bill, or ask if there is financial assistance available.</p><p>You may also start a dispute resolution process with the U.S. Department of Health and Human Services (HHS). If you choose to use the dispute resolution process, you must start the dispute process within 120 calendar days (about 4 months) of the date on the original bill.</p><p>There is a $25 fee to use the dispute process. If the agency reviewing your dispute agrees with you, you will have to pay the price on this Good Faith Estimate. If the agency disagrees with you and agrees with the health care provider or facility, you will have to pay the higher amount.</p><p>To learn more and get a form to start the process, go to www.cms.gov/nosurprises or call 1-877-696-6775.</p><p>For questions or more information about your right to a Good Faith Estimate or the dispute process, visit www.cms.gov/nosurprises or call 1-877-696-6775.</p><p>Keep a copy of this Good Faith Estimate in a safe place or take pictures of it. You may need it if you are billed a higher amount.</p>",
      "estimateRequestedAmountNotice": "{{ amount }} Due By {{ DOS }}",
      "estimateAmountPaid": "You paid {{ amount }}",
      "cardHolderName": "Cardholder Name: {{name}}",
      "billSummaryHeader": "How Your Cost Was Calculated",
      "billSummaryServiceAmount": "Total Charges:",
      "billSummaryInsuranceCoverage": "Insurance Coverage:",
      "billSummaryOtherAdjustments": "Payments & Adjustments:",
      "billSummaryPatientPaid": "Patient Payments:",
      "billSummaryCost": "Total Amount Due:",
      "primaryInsurance": "Primary Insurance:",
      "primaryInsuranceNoColon": "Primary Insurance",
      "totalAmountDue": "Total Amount Due",
      "billReasons": "Your Bill Includes:",
      "estimates": "Estimates",
      "bills": "Bills",
      "upcoming": "Upcoming",
      "youHavePaid": "You've Paid",
      "dueBy": "Due By",
      "by": "by",
      "accountInfo": "Account Info",
      "seeAll": "See All",
      "services": "Services",
      "patientPayments": "Patient Payments",
      "serviceCharges": "Service Charges",
      "insuranceContribution": "Insurance Contribution",
      "insuranceCoverage": "Insurance Coverage",
      "insurancePayments": "Insurance Payments",
      "insurancePaymentsPending": "Insurance Payments Pending",
      "insuranceAdjustments": "Insurance Adjustments",
      "providerAdjustments": "Provider Adjustments",
      "otherAdjustments": "Other Adjustments",
      "totalCharges": "Total Charges",
      "noEstimate": "No Estimates Yet",
      "noEstimateDetails": "Estimates for upcoming services will appear here.",
      "noBillDetails": "New bills will appear here as they are processed.",
      "noBill": "No Bills Yet",
      "noActivity": "No Activity Yet",
      "noActivityDetails": "Account activity will appear here.",
      "inNetworkProvider": "In-Network Provider",
      "servicesFor": "Services For:",
      "accountNumberShort": "Account #",
      "enterSecureHealthCode": "Enter SecureHealthCode",
      "enterBillAmount": "Enter bill amount",
      "findABill": "Find a Bill",
      "findABillDescription": "Enter the details from your most recent paper statement.",
      "accountBalance": "Account Balance",
      "accountDetails": "Account Details",
      "balanceTransferred": "Balance Transferred",
      "saveEcheck": "Save eCheck for future use",
      "saveCard": "Save Card for future use",
      "expDate": "Expires {{ date }}",
      "expires": "This card expires {{ date }}. Choose an earlier payment date.",
      "expired": "This card expired {{ date }}.",
      "estimatedRemaining": "Estimated Remaining",
      "estimatedRemainingCost": "Estimated Remaining Cost",
      "originalEstimatedCost": "Original Estimated Cost",
      "estimateVoid": "This estimate is no longer valid and payments cannot be made.",
      "infoAndDisclaimers": "Important Information & Disclaimers"
    },
    "linkedAccounts": {
      "activeAccounts": "Active Accounts",
      "providerName": "Provider",
      "accountNum": "Account Number",
      "billingName": "Patient Name",
      "disassociate": "Remove",
      "noAssociatedAcc": "There are no active accounts.",
      "confirmDisassociation": "Are you sure you want to <br />remove this account?",
      "accountInfoLabel": "Warning! Once you confirm, all data associated with this account will be removed.<br /><br /> <b>{{guarantorName}}</b><br />Account:&nbsp;{{accountNumber}}",
      "accountRemoved": "Account #&nbsp;{{accountNumber}}",
      "argMethodDisassociated": "<b>{{guarantorName}}</b><br />has been removed.",
      "disassociateError": "Oops, something went wrong. Please try again."
    },
    "paymentForm": {
      "method": {
        "stepName": "Method"
      },
      "billing": {
        "stepName": "Address"
      },
      "confirm": {
        "stepName": "Confirmation"
      }
    },
    "payment": {
      "amount": {
        "question": "How much would you like to pay?",
        "selectDifferent": "Please select a different payment option:",
        "stepName": "Payment Amount",
        "agreementStepName": "Payment Agreement Amount",
        "agreementAmountSummary": "{{agreementAmount}} pending",
        "payBillBalArg": "Pay Bill Amount: <b>{{calculatedTotal}}</b>",
        "payBillBalArgDiscount": "Pay Bill Amount with {{discountPolicy}}&nbsp;Discount:<br /><b>{{calculatedTotal}}</b>",
        "payAccountBalArg": "Pay Account Balance: <b>{{calculatedTotal}}</b>",
        "payAccountBalArgDiscount": "Pay Account Balance with {{discountPolicy}}&nbsp;Discount:<br /><b>{{calculatedTotal}}</b>",
        "payAnother": "Pay Another Amount",
        "otherPaymentOptions": "Review Other Payment Options",
        "payOnce": "Would you like to make a one-time payment?",
        "payOverTime": "Would you like to pay over time?",
        "updateExistingPlan": "Would you like to update your existing<br/> payment plan to include the new charges?",
        "planInstallmentOption": "{{installmentAmount}}/month, {{installmentCount}} months",
        "messageProvider": "Message Provider",
        "noneOfTheseOptionsWorkForMe": "None Of These Options Work For Me",
        "reviewFinancingOptions": "Review Financing Options",
        "lowMonthlyPaymentOptions": "Low Monthly Payment Options",
        "paymentsAsLowAs": "Payments As Low As {{monthlyPayment | currency}}/Month*",
        "paymentsAsLowAsDisclaimer": "* {{monthlyPayment | currency}} minimum monthly payment is estimated based on {{amount | currency}} financed at {{apr}}% APR for {{duration}} months. Actual APR varies between 0% and 29.99% and repayment terms vary between 24 and 48 months, depending on your creditworthiness. Payments will vary depending on loan amount and offer received.",
        "getFinancingOptionsErrorMessage": "An error occurred while trying to load your financing options. Please try again.",
        "noFinancialOptionsFound": "Sorry, we did not find any financing options to offer you.",
        "planDisabledBecauseOfBadDebt": "Payment plans cannot be created on accounts that have been referred to an external agency.",
        "singlePaymentPlanDisclaimer": "You have an existing payment plan with {{providerName}}. To add new balances to your plan, please <a ng-click=\"VueEventTransmitter.$emit('message:compose', { secureCode: bill.secureCode });\">send us a message</a> or contact Customer Service at {{providerPhoneNumber}}.",
        "singlePaymentPlanDisclaimerNoMessaging": "You have an existing payment plan with {{providerName}}. To add new balances to your plan, please contact Customer Service at {{providerPhoneNumber}}.",
        "existingPaymentPlanOnAccountDisclaimar": "You have an existing payment plan on this account",
        "wouldLikeAssistanceSettingUpPaymentPlan": "I would like assistance in setting up a payment plan",
        "payEstimateBal": "Pay Estimate Amount: {{calculatedTotal}}",
        "payEstimateRequestedAmount": "Pay {{percentage}}% of Estimate Amount: {{calculatedTotal}}",
        "payEstimateBalAgreement": "Enroll in a Payment Agreement for the remaining amount: {{calculatedTotal}}",
        "estimateRemainder": "How would you like to pay the remainder?",
        "cannotPayToday": "I can't pay <b>today</b>"
      },
      "date": {
        "question": "When would you like to pay?",
        "stepName": "Payment Date",
        "firstPaymentDate": "First Payment Date",
        "todayArg": "Today: <b>{{todayDate}}</b>",
        "laterDate": "Pay At A Later Date",
        "dateFromExistingPlan": "Next date in plan: <b>{{nextDate}}</b>",
        "agreementDateSummary": "On or after {{date}}"
      },
      "method": {
        "question": "How would you like to pay?",
        "stepName": "Payment Method",
        "cardMethod": "Credit/Debit Card",
        "eCheckMethod": "eCheck",
        "hsaMethod": "HSA/FSA Card",
        "userAnotherCard": "Use Another Card",
        "userAnotherECheck": "Use Another eCheck",
        "userAnotherCardOrECheck": "Use Another Card or eCheck"
      },
      "billing": {
        "question": "What's your billing address for <br />{{methodSummary}}?",
        "stepName": "Billing Address",
        "useAnotherAddress": "Use Another Billing Address",
        "billingAddressSection": "Enter Billing Address."
      },
      "confirm": {
        "planAmount": "{{installmentAmount}}/month for {{installmentCount}} months",
        "question": "Does everything look right?",
        "stepName": "Confirmation",
        "cardBilling": "Card Billing Address",
        "eCheckBilling": "eCheck Billing Address",
        "eCheckAuthorizationSingle": "I authorize Patientco on behalf of {{providerName}} to initiate a single electronic debit from my account in the amount of {{amountSummary}} on {{date}} from the bank account on record. I understand this authorization will remain in effect until I notify {{providerName}} that I wish to revoke it.",
        "eCheckAuthorizationPaymentPlan": "I authorize Patientco on behalf of {{providerName}} to initiate recurring electronic debits from my account in the amount of {{amountSummary}} starting on {{date}} from the bank account on record. I understand this authorization will remain in effect until I notify {{providerName}} that I wish to revoke it.",
        "paymentAgreementStepName": "Payment Agreement",
        "paymentAgreement": "I authorize {{providerName}} to apply a charge for the Payment Agreement amount indicated above on or after {{date}}. I understand that I will receive notice 3 days prior to the payment being collected, and that I can cancel before the payment is processed. This permission is for a single transaction only and does not provide authorization for any additional unrelated debits or credits."
      },
      "friendlyType": {
        "standard": "Payment",
        "badDebt": "Bad Debt Payment",
        "balance": "Balance Payment",
        "copay": "Copay",
        "insurance": "Insurance Payment",
        "prepayment": "Pre-payment",
        "other": "Other",
        "agreement": "Authorized amount to charge"
      },
      "financing": {
        "application": {
          "stepName": "Financing Application",
          "financingApplyHeader": "To see if offers are available, complete this form:",
          "electronicDisclosureConsentText": "By checking the box, you certify that you have read, retained, and agree to the <a href='{{electronicDisclosureConsentLink}}' target='_blank'>Consent to Electronic Disclosures</a> and understand that this constitutes your electronic signature authorizing us to process this form on your behalf.",
          "electronicDisclosureConsentError": "Agreeing to the Consent of Electronic Disclosures is required.",
          "creditScoreNotice": "Viewing offers does not impact your credit score.",
          "financingViewOffers": "View My Offers",
          "monthlyIncomeHeader": "Total Gross Monthly Household Income",
          "monthlyIncomeBody": "Alimony, child support or separate maintenance income need not be included if you do not wish to have it considered as a basis for repaying this obligation.<br><br>Married Wisconsin Residents: Combine your and your spouse's information on this application.",
          "incomeGreaterThanZeroError": "Income must be greater than zero.",
          "disclaimersHeader": "Read the Disclaimers Below & Scroll Down to View Your Offers",
          "newAccountProceduresHeader": "Important Information About Procedures for Opening a New Account",
          "newAccountProceduresBody": "To help the government fight the funding of terrorism and money laundering activities, Federal law requires all financial institutions to obtain, verify, and record information that identifies each person who opens an account. What this means for you: When you apply for a loan, we will ask your name, street address, email address, date of birth and other information which will allow us to identify you. We may also ask to see your driver's license or other identifying documents.",
          "stateLawNoticesHeader": "State Law Notices",
          "stateLawNoticesBody": "<p><b>California Residents:</b> If married, you may apply for a separate account.</p><p><b>Delaware Residents:</b> Service charges not in excess of those permitted by law will be charged on the outstanding balances from month to month.</p><p><b>Maryland Residents:</b> Finance Charges will be imposed in amounts or at rates not in excess of those permitted by law.</p><p><b>New York Residents:</b> New York residents may contact the New York State Department of Financial Services by telephone or visit its website for free information on comparative credit card rates, fees, and grace periods. You can call the New York State Department of Financial Services at 800-342-3736 or visit its website: www.dfs.ny.gov.</p><p><b>Ohio Residents:</b> The Ohio laws against discrimination require that all creditors make credit equally available to all credit-worthy customers, and that credit reporting agencies maintain separate credit histories on each individual upon request. The Ohio civil rights commission administers compliance with this law.</p><p><b>Vermont Residents:</b> Lender is engaged in loan production.</p><p><b>Married Wisconsin Residents:</b> No provision of a marital property agreement, a unilateral statement under section 766.59 or a court decree under section 766.70 adversely affects the interest of the creditor unless the creditor, prior to the time the credit is granted, is furnished a copy of the agreement, statement or decree or has actual knowledge of the adverse provision when the obligation to the creditor is incurred. We are required to ask you to provide the name and address of your spouse.</p>",
          "electronicCommunicationConsentTitle": "Special Consent to Electronic Communication",
          "electronicCommunicationConsentBody": "By clicking \"View My Offers\" below and submitting an application electronically for processing, you expressly authorize the Lender to contact you about your application and any credit extended, or for any other lawful purpose, including, without limitation, customer service or collection, at any address or telephone number that you may, from time to time, provide (including any cellular telephone number or ported landline), and expressly including, without limitation, calls made using automatic dialing and announcing devices that may play recorded messages.",
          "submitApplicationConsentTitle": "Consent to Submit Application",
          "submitApplicationConsentBody": "By clicking \"View My Offers\" below and submitting an application electronically for processing, you hereby certify that you are at least 18 years of age (19 in AL or NE) and that everything you have stated above is true and accurate. You certify that you do not presently have a petition filed under federal bankruptcy laws (whether voluntary or involuntary) and do not anticipate filing a petition. If approved for credit, you agree to be bound by the terms of the Credit Agreement provided to you. You authorize The Bank of Missouri, its successors, assigns, and agents (the \"Lender\") to investigate your creditworthiness and to obtain a credit report on you for any lawful purpose, including any update, extension of credit, review or collection of your account, and you authorize the release of such information to the Lender. If you request, the Lender will tell you whether any credit report was requested, and if so, the name and address of the consumer reporting agency furnishing the report."
        },
        "offers": {
          "stepName": "Available Offers",
          "financingOptionsHeaderMultiple": "Congratulations, offers are available",
          "financingOptionsHeaderSingle": "Congratulations! Here is your offer",
          "financingOptionHeaderCreditLimit": " with a {{currencyCreditLimit}} Credit Limit.",
          "financingOptionCreditLimit": "Credit Limit: {{currencyCreditLimit}}",
          "financingOptionHeaderDeferredInterest": "If paid in full within {{deferredInterestMonths}} months",
          "financingOptionDeferredInterest": "Deferred Interest: {{deferredInterestMonths}} months",
          "financingOptionNoInterest": "No Interest",
          "financingOptionLowMonthly": "Low Monthly Payment",
          "financingOptionAmountAndMonths": "{{currencyMonthlyAmount}}/month for {{months}} months",
          "financingOptionAPR": "Annual Percentage Rate: {{rate}}%",
          "financingOptionInterestBearing": "{{currencyMonthlyAmount}}/month, {{months}} months, {{rate}}% interest",
          "financingOptionInterestFree": "{{currencyMonthlyAmount}}/month, {{months}} months",
          "chooseFinancingOptionErrorMessage": "An error occurred while communicating with our financing partner. Please try again.",
          "monthlyPaymentDisclaimer": "Monthly Payment: The estimated monthly minimum payments include finance charges at an APR of the value shown on the corresponding offer tile and an estimated total payment the minimum monthly payment multiplied by the repayment term. Assuming the purchase amount of {{chargeAmount | currency}} and that all payments are timely made, the purchase transaction will be paid off within the number of months listed for repayment term on the corresponding offer tile.",
          "deferredInterestDisclaimer": "Deferred Interest: Interest will be charged to your account from the purchase date if the qualifying purchase balance is not paid in full within the promotional period or if you make a late payment. You must pay more than your required minimum payment to avoid interest. See Cardholder Agreement for details."
        },
        "existingAccount": {
          "stepName": "Confirmation",
          "existingAccountHeader": "Based on the information provided, we have found an existing {{existingAccount.vendorName}} account.",
          "accountNumberLabel": "Account Number:",
          "availableCreditLabel": "Available Credit:",
          "authorizeTransactionSubheader": "Authorize Transaction for {{chargeAmount | currency}}",
          "authorizeTransactionDisclaimer": "By checking the box, you agree to allow {{existingAccount.vendorName}} to initiate a transaction for the appropriate bill amount.  If your line of credit is greater than your bill amount, you will be able to use it towards future bills with {{providerName}} if you would like.",
          "submitExistingAccountConfirmationErrorMessage": "An error occurred while communicating with our financing partner. Please try again.",
          "partialPaymentDisclaimer": "Please note you will have a remaining balance of {{existingAccount.amountDueNotCovered | currency}}."
        },
        "summary": {
          "stepName": "Summary of Credit Terms",
          "financingSummaryHeader": "Review & Accept Your Offer:",
          "acceptOfferDisclaimer": "Once you click Accept Offer, your {{vendorName}} account will be created and you will not be able to select a different offer.",
          "acceptOfferButton": "Accept Offer",
          "reviewTerms": "Before selecting your offer, please review the <a id='summary-terms' href='{{termsUrl}}' target='_blank'>Summary of Credit Terms</a> which summarizes the key terms of the Cardholder Agreement that will govern your {{vendor}} revolving account."
        },
        "confirm": {
          "stepName": "Confirmation",
          "financingConfirmHeader": "Almost Done!",
          "cardholderAgreementSubheader": "Read & Save Your Cardholder Agreement:",
          "cardholderAgreementDisclaimer": "By checking the box, you agree that you have (i) read and understand your <a id='cardholder-agreement' href='{{cardholderAgreementUrl}}' target='_blank'>Cardholder Agreement</a> including the terms of any deferred interest offer and agree to be bound by its terms, and (ii) have provided the correct email address in order to retain a copy of the Cardholder Agreement for your records.",
          "authorizeTransactionSubheader": "Authorize Transaction for {{chargeAmount | currency}}",
          "authorizeTransactionDisclaimer": "By checking the box, you agree to allow {{vendorChosen}} to initiate a transaction for {{chargeAmount | currency}}. If your line of credit is greater than this amount, you will be able to use it towards future bills with {{providerName}} if you would like.",
          "partialPaymentDisclaimer": "Please note you will have a remaining balance of {{selectedOption.amountDueNotCovered | currency}}."
        },
        "success": {
          "financingRedirectHeader": "We will redirect you shortly...",
          "financeRedirectSubContent": "<br>If you are not redirected automatically<br>please <a id='redirectUrl' href='{{redirectUrl}}' target='_blank'>click here</a> to continue.",
          "financingSuccessHeader": "Thank you for financing through {{vendor}}!",
          "financeSuccessSubContent": "{{vendor}} will contact you directly with account details. If you have any questions, please contact {{vendor}} directly by phone at <b>{{vendorPhone}}</b> or by email at <b>{{vendorEmail}}</b>."
        },
        "paymentForm": {
          "infoHeader": "{{vendor}} Card",
          "infoContent": "<p>Based on your existing account with {{vendor}}, you are able to use your open line of credit to finance your bills with <b>{{provider}}</b>.</p><p>Available Credit: {{formattedAvailableCredit}}</p><p>For questions about your {{vendor}} account, please call {{vendorPhone}} or email {{vendorEmail}}.</p>"
        },
        "status": {
          "approved": {
            "title": "Thank you for enrolling with {{vendor}}!",
            "subtitle": "Check your inbox in the next few days for<br>additonal account information from {{vendor}}."
          },
          "pending": {
            "title": "Enrollment Information Under Review",
            "subtitle": "Your information has been submitted to a {{vendor}} specialist for verification."
          },
          "rejected": {
            "title": "Please Contact Your Healthcare Provider",
            "subtitle": "Your account setup requires assistance from {{provider}}. Please contact {{provider}} at {{phoneNumber}} for further assistance."
          }
        },
        "errors": {
          "firstName": "Please check your first name, and try again.",
          "lastName": "Please check your last name, and try again.",
          "email": "Please check your email address, and try again.",
          "primaryPhone": "Please check your primary phone number, and try again.",
          "dob": "Please check your date of birth, and try again.",
          "ssn": "Please check your social security number, and try again.",
          "monthlyIncome": "Please check your monthly household income, and try again.",
          "addressLine1": "Please check your address, and try again.",
          "addressLine2": "Please check your address line 2, and try again.",
          "poBox": "We do not allow PO Boxes at this time. Please enter a different address, and try again.",
          "city": "Please check your city, and try again.",
          "stateZip": "Please make sure your zip code and state are correct, and try again.",
          "tryAgain": "@:payment.amount.getFinancingOptionsErrorMessage",
          "alreadyHasAnAccount": "It looks like there is already an account associated with this social security number. Please make sure to use the same email address and date of birth and try again."
        }
      }
    },
    "newPaymentFormFlow": {
      "genericError": "There was an error saving your payment method.",
      "saveMethod": "Save Method",
      "title": "New Payment Method"
    },
    "paymentFlow": {
      "amount": {
        "accessOneTitle": "Explore financing options through AccessOne",
        "accountBalanceTitle": "Pay account balance: {{amount}}",
        "accountBalanceDiscountTitle": "Pay account balance and get {{percent}} off:",
        "clearBalanceSuccessText": "Check your inbox in the next few days for additional account information from ClearBalance.",
        "clearBalanceSuccessTitle": "Thank you for enrolling with ClearBalance",
        "clearBalanceTitle": "Explore financing options through ClearBalance",
        "curaeTitle": "Explore financing options through Curae",
        "desktopPrompt": "Choose how much you would like to pay.",
        "estimateRequestedAmountTitle": "Pay {{percent}}% pre-payment: {{amount}}",
        "estimateRequestedAmountSubtitle": "Pay part today, pay the rest later",
        "estimateRequestedRemainingAmountTitle": "Pay remaining pre-payment: {{amount}}",
        "estimateTotalAmountRemainingTitle": "Pay estimated remaining cost: {{amount}}",
        "estimateTotalAmountTitle": "Pay total estimated cost: {{amount}}",
        "mobilePrompt": "Choose an option.",
        "partialPaymentTitle": "Make a partial payment",
        "partialPaymentSubtitle": "Customize your amount",
        "oneTimePayment": "One-time payment",
        "errors": {
          "amountNotPositive": "Amount must be greater than $0.00.",
          "amountTooHigh": "Amount must be less than or equal to your balance.",
          "amountTooLow": "Amount must be greater than or equal to {{minAmount}}."
        },
        "financingSubtitle": "Get pre-approved for free with no impact to your credit score",
        "paymentPlan": {
          "title": "Create a payment plan",
          "updateTitle": "Update payment plan",
          "subtitle": "Interest free, automatic",
          "installmentOptionHeader": "{{ formattedAmount }} / month",
          "installmentOptionSubheader": "for {{ numberOfMonths }} months"
        },
        "statementBalanceTitle": "Pay statement balance: {{amount}}",
        "statementBalanceDiscountTitle": "Pay statement balance and get {{percent}} off:",
        "subAccountBalanceTitle": "Total Amount: {{amount}}",
        "updatePlan": {
          "amountPerMonth": "{{ formattedAmount }}/month",
          "numberOfPaymentsMade": "{{ amountCompleted }} of {{ totalAmount }} payments made",
          "prompt": "Choose new terms for your plan.",
          "title": "Update payment plan",
          "subtitle": "Include new charges in your existing plan",
          "yourCurrentPlan": "Your current plan:"
        }
      },
      "date": {
        "prompt": "Choose when you would like to pay.",
        "paymentPlanPrompt": "Choose when you would like your payment plan to start.",
        "updatePlanHeader": "Monthly, on the {{ formattedDate }}",
        "updatePlanPrompt": "Choose your next payment date.",
        "updatePlanSubheader": "Next payment scheduled for {{ formattedDate }}",
        "updatePlanYourCurrentPlan": "Your current plan:"
      },
      "financing": {
        "accessOne": {
          "congratulations": "Congratulations! Here is your offer:",
          "continue": "Continue with AccessOne",
          "disclaimer": "The offer(s) above are options provided by our trusted financing partner, AccessOne. You will be redirected to complete the application process.",
          "amountPerMonth": "{{ formattedAmount }}/month",
          "amountPerMonthWithInterest": "{{ formattedAmount }}/month + {{interestRate}}% interest",
          "length": "For {{ numberOfMonths }} months",
          "error": "An error occurred while communicating with AccessOne. Please try again."
        },
        "curae": {
          "viewOffers": "View My Offers",
          "completeFormTitle": "Complete this form to see available offers.",
          "completeFormSubtitle": "Viewing offers will not impact your credit score.",
          "personalInformation": "Personal Information",
          "bankAccount": "All Curae accounts are issued by The Bank of Missouri, St. Robert, MO.",
          "mulitpleOffersTitle": "Congratulations! We have offers available with a ${{ creditLimit }} credit limit.",
          "oneOfferTitle": "Congratulations! We have an offer available with a ${{ creditLimit }} credit limit.",
          "amountNoApr": "${{ amount }}/month 0% APR",
          "amountApr": "${{ amount }}/month + {{ apr }}% APR",
          "amountAprDeffered": "${{ amount }}/month + {{ apr }}% APR*",
          "months": "For {{ months }} months",
          "deferredInterest": "* No interest if paid in full within {{ months }} months",
          "reviewOffer": "Review and accept your offer.*",
          "creditLimit": "Credit Limit: ${{ creditLimit }}",
          "onceAccepted": "* Once accepted, your Curae accept will be created and you will not be able to select a different offer.",
          "cardholderAgreement": "Cardholder Agreement",
          "authorizeTransactionTitle": "Authorize Transaction for ${{ money }}",
          "authorizeTransactionBody": "By checking this box, you agree to allow Curae to process a transaction for <strong>${{ amount }}</strong>. If your line of credit is greater than this amount, you will be able to use it towards future bills with {{ provider }}.",
          "acceptAndProcess": "Accept & Process",
          "cardholderAgreementError": "Agreeing to the Cardholder Agreement is required.",
          "authorizeTransactionError": "Agreeing to Authorize the Transaction is required.",
          "electronicDisclosureConsentText": "By checking the box, you certify that you have read and retained the information above, and that you agree to the <a id='electronic-disclosures' href='{{electronicDisclosureConsentLink}}' target='_blank'>Consent to Electronic Disclosures</a>. Checking this box also constitutes your electronic signature, authorizing us to process this form on your behalf.",
          "newMonthlyIncomeBody": "Alimony, child support or separate maintenance income need not be included if you do not wish to have it considered as a basis for repaying this obligation.",
          "wisconsinResidents": "Married Wisconsin Residents",
          "wisconsinResidentsBody": "Combine your and your spouse's information on this application.",
          "newAccountProceduresHeader": "Procedures for Opening an Account"
        },
        "noOffers": {
          "title": "No offers available",
          "body": "Unfortunately we did not find any financing options to offer you at this time. Please choose a different payment option or contact your provide for further assistance."
        },
        "redirect": {
          "title": "We will redirect you shortly",
          "body": "If you are not redirected automatically, click the button below to continue.",
          "action": "Redirect"
        }
      },
      "method": {
        "prompt": "Choose how you would like to pay.",
        "newCard": "New credit/debit"
      },
      "confirmation": {
        "estimateDisclaimer": "This payment plan is only for this estimate. After your healthcare service is rendered and a statement is issued, this payment plan will be terminated. Any remaining balance will be reflected on your statement.",
        "paymentPlanMonthlyDate": "Monthly, on the {{ formattedDate }}",
        "paymentPlanFirstPaymentDate": "First Payment: {{ formattedDate }}"
      },
      "confirmCancel": {
        "cancelPayment": "Cancel Payment?",
        "paymentNotProcessed": "Your payment will not be processed.",
        "noContinuePaying": "NO, CONTINUE PAYING",
        "yesCancelPayment": "YES, CANCEL PAYMENT"
      },
      "actions": {
        "back": "Back",
        "cancel": "Cancel",
        "continue": "Continue",
        "processing": "Processing...",
        "processPayment": "Process Payment",
        "processPaymentFuture": "Schedule Payment"
      },
      "backButtons": {
        "accountDetails": "Account...{{accountNumber}}",
        "billSummary": "Bill Summary",
        "estimateSummary": "Estimate Summary",
        "amount": "Payment Option",
        "date": "Payment Date",
        "method": "Payment Method"
      },
      "steps": {
        "amount": "Payment Option",
        "availableOffers": "Available Offers",
        "curaeApplication": "Curae Application",
        "date": "Payment Date",
        "acceptOffer": "Accept Offer",
        "method": "Payment Method",
        "confirmation": "Confirmation"
      },
      "errors": {
        "generic": "There was an error while processing your payment. Please try again later or contact your provider at {{phoneNumber}} to complete your payment.",
        "methodUnavailableAll": "We are currently experiencing difficulty processing payments. We apologize for the inconvenience. Please try again later.",
        "methodUnavailableCard": "We are currently experiencing difficulty processing card payments. Please try again using a different payment method or contact your provider at {{phoneNumber}} to complete your payment.",
        "methodUnavailableECheck": "We are currently experiencing difficulty processing eCheck payments. Please try again using a different payment method or contact your provider at {{phoneNumber}} to complete your payment.",
        "paymentCardExpired": "This card has expired. Try using a different payment method.",
        "paymentDeclined": "This card was declined. Try using a different payment method.",
        "paymentDuplicate": "It looks like you're trying to submit a duplicate payment. If this was intentional, please contact your provider at {{phoneNumber}} to complete your payment.",
        "paymentInvalidCard": "This does not appear to be a valid card. Try checking the card number and expiration date, or use a different payment method.",
        "prematureExpiration": "This card will expire before your payment date. Please choose a different date or use a different payment method.",
        "invalidParameters": "There appears to be an invalid parameter. Please correct it any issues and try again.",
        "paymentProcessingError": "There was an issue while processing your payment. Please try again.",
        "accountPaidInFull": "The account is already paid in full.",
        "networkError": "There was a network error while trying to process your payment. Please try again."
      }
    },
    "dialogs": {
      "confirmPasswordHeader": "Confirm Password",
      "confirmPasswordSubheader": "For security reasons, please enter your password.",
      "deactivateAccountHeader": "Deactivate Account",
      "deactivateAccountSubheader": "For security reasons, please enter your password to continue.",
      "deactivateAccountWarning": "Warning! Once you deactivate your account, you will lose access to your PatientWallet<sup>&reg;</sup> and all data associated with it.",
      "deactivateAccountSuccessHeader": "Your account has been deactivated.",
      "deactivateAccountSuccessSubheader": "If you have deactivated your account in error, please contact us at 1-844-422-4779 or support@patientco.com.",
      "thanksForPayment": "Thank you for your payment!",
      "emailSentTo": "We've sent an email receipt to<br />{{email}}",
      "copySentTo": "When your provider responds, we'll send an email to<br />{{email}}",
      "successfulLogout": "You've successfully logged out.",
      "thanksAndComeBack": "Thank you for using Patientco.<br />We look forward to having you back!",
      "welcome": "Welcome to Patientco!",
      "happyYouAreHere": "Create an account to get started.",
      "thanksForComingBack": "We're glad to have you back.",
      "leavingPaymentFlow": "Are you sure you want to leave this page? Your payment has not been processed.",
      "yourBalanceWasUpdated": "Your balance has been updated!",
      "dbuReasonHeaderUp": "Why has my balance gone up?",
      "dbuReasonHeaderDown": "Why has my balance gone down?",
      "dbuReason": "Since your last bill, there has been new activity on your account. In most cases, the updated balance reflects new charges, payments, or insurance contribution changes.",
      "dbuStillPayable": "Don't worry, you can still pay<br />the amount printed on your bill.",
      "newerBillLoaded": "The details you've entered are from an old bill. For your convenience, we have loaded the most recent bill that reflects your latest information.",
      "demoDialog": "Demo Environment",
      "gatewayDown": "We are currently experiencing difficulty processing payments.  We apologize for the inconvenience, please try again later.",
      "cardsHidden": "We are currently experiencing difficulty processing credit card payments. Please make your payment using an echeck.",
      "eChecksHidden": "We are currently experiencing difficulty processing echeck payments. Please make your payment using a credit card.",
      "cardsExpired": "At least one of your credit cards has expired, or will expire before the date your scheduled payment date.",
      "contactTitle": "Thanks for reaching out!",
      "contactSubtitle": "We're excited to hear from you.",
      "phiWarning": "For your security, please exclude personal health information.",
      "contactSent": "Thank you for your message!",
      "contactThanks": "We'll get back to you as soon as possible.",
      "termsTitle": "Terms of Use",
      "welcomeBack": "Welcome back, {{name}}!",
      "termsUpdated": "Updates to Terms of Use<br/>& Privacy Policy",
      "logoutWarningHeader": "Your session is about to expire",
      "logoutWarningSubcontent": "For your security, this online session will end shortly due to inactivity.",
      "activeChatWarningHeader": "Active chat session",
      "activeChatWarningSubcontent": "You currently have an active chat session that will be terminated. Are you sure you want to log out?",
      "retryProcessPayment": "We were unable to fully process your payment. Please retry your submission below. Don't worry, we will only charge your card once.",
      "feedbackTitleReceiptLink": "How was your online payment experience?",
      "feedbackTitleClosedMessageLink": "How was your customer service from {{providerName}}?",
      "feedbackTitleNpsLink": "Given your billing experience, how likely are you to recommend {{providerName}} to a friend or colleague?",
      "feedbackSubtitlePaymentHappy": "Great! Any other comments?",
      "feedbackSubtitlePaymentSad": "Sorry to hear that! How can we improve?",
      "feedbackSubtitleClosedMessageHappy": "Great! Any other comments?",
      "feedbackSubtitleClosedMessageSad": "Sorry to hear that! What could your provider do better?",
      "feedbackSubtitleNpsHappy": "Great! Any other comments?",
      "feedbackSubtitleNpsSad": "We’re sorry to hear that. Care to tell us why?<br>Your feedback will help us improve.",
      "feedbackCommentPlaceholder": "Start typing feedback...",
      "feedbackLabelNPS0": "Not at all likely",
      "feedbackLabelNPS10": "Extremely likely",
      "feedbackOptionOther": "Other",
      "thanksForFeedback": "Thank you for your feedback!",
      "accountIsFinanced": "This account is currently being serviced by {{financedBy}}.",
      "contactFinancingVendor": "To make a payment or for help with your account, please contact {{financedBy}} directly.",
      "updatePaymentFormConfirmHeader": "Change Payment Method?",
      "updatePaymentMethodButtonText": "Confirm",
      "updatingPaymentMethodButtonText": "Updating...",
      "updateAndApplyPaymentMethodButtonText": "Confirm",
      "updateAndApplyingPaymentMethodButtonText": "Processing...",
      "confirmingButtonText": "Confirming...",
      "addAnotherCard": "Add Another Card",
      "addAnotherECheck": "Add Another eCheck",
      "addAnotherCardOrECheck": "Add Another Card or eCheck",
      "updatesToTermsText": "We have updated our <a href=\"https://www.waystar.com/patientco-terms-of-use/\" target=\"_blank\">Terms of Use</a> and <a href=\"https://www.waystar.com/patientco-privacy-policy/\" target=\"_blank\">Privacy Policy</a> to make it easier for you to understand what information we collect and why. <br/><br/> As a friendly reminder, Patientco will never share your information with third party marketers, and you can always update your Communication Preferences within your Settings.  We encourage you to review our new <a href=\"https://www.waystar.com/patientco-terms-of-use/\" target=\"_blank\">Terms of Use</a> and <a href=\"https://www.waystar.com/patientco-privacy-policy/\" target=\"_blank\">Privacy Policy</a>. <br/><br/> To accept the new <a href=\"https://www.waystar.com/patientco-terms-of-use/\" target=\"_blank\">Terms of Use</a> and <a href=\"https://www.waystar.com/patientco-privacy-policy/\" target=\"_blank\">Privacy Policy</a>, click \"Accept\" below.",
      "clearBalanceInfoFunded": "If you have elected to participate in the ClearBalance program, your balance will be reflected as a $0 balance. Please remit your payments to ClearBalance at <a href='https://www.myclearbalance.com' target='_blank'>https://www.myclearbalance.com</a>. The ClearBalance funding will show in your PatientWallet<sup>&reg;</sup> transactions as a ClearBalance Program disbursement.",
      "clearBalanceInfoApplied": "If you have elected to participate in the ClearBalance program, your balance will be reflected as a $0 balance once you make your first standard minimum payment. Please remit your payments to ClearBalance at <a href='https://www.myclearbalance.com' target='_blank'>https://www.myclearbalance.com</a>.",
      "removeCardTitle": "Remove Card?",
      "removeCardContent": "This card will be deleted from your PatientWallet.",
      "confirmChangePaymentMethod": "This payment method will be used for the remaining payments on your plan.",
      "chooseDifferentMethod": "Choose a different method."
    },
    "links": {
      "whyPatientco": "About",
      "news": "News",
      "termsOfService": "Terms",
      "careers": "Careers",
      "privacyPolicy": "Privacy"
    },
    "misc": {
      "conjunction": "and",
      "on": "on"
    },
    "errors": {
      "email": "Please enter an email address that matches standard format. Here's an example: james.smith@example.com.",
      "emailUnavailable": "You've entered an email address that has already been registered. Try logging in to access your information.",
      "emailInUse": "You've entered an email address that has already been registered.",
      "password": "Your password must contain at least 8 characters, 1 uppercase letter, and 1 number.",
      "confirmPassword": "It looks like the passwords you have entered don't match! Double check to make sure both entries are exactly the same.",
      "allNumericSCode": "We cannot find a bill matching that SecureHealthCode. The SecureHealthCode can be found in the Pay Online section of your bill.",
      "scodeRequired": "Please enter the green SecureHealthCode located in the top right section of your bill below the Patientco logo.",
      "amountRequired": "Please enter the total balance printed on your bill. We'll ask for your desired payment amount in the next step.",
      "belowMinAmount": "You've entered a bill with a negative amount. Please enter the total balance printed on your bill.",
      "unableToFindBill": "We cannot find a bill matching the SecureHealthCode and total balance you've entered. Please check to make sure your details are correct.",
      "billThrottled": "You have attempted to find a bill too many times. For security reasons, your ability to search for bills has been disabled for a few minutes.",
      "unableToLogin": "The email address or password you've entered is incorrect.",
      "loginThrottled": "You have attempted to login too many times. For security reasons, your ability to login has been disabled for a few minutes.",
      "loginEmailRequired": "Please enter an email address to help us find your account.",
      "loginPasswordRequired": "Please enter your account password to log in to Patientco.",
      "minAmountArg": "Your payment amount must be greater than {{minAmount}}",
      "maxAmountArg": "Your payment amount must be less than or equal to your account balance of {{maxAmount}}",
      "dateRequired": "Please select a date from the calendar.",
      "ccRequired": "Please enter a credit or debit card number.",
      "ccSeemsInvalid": "Please enter a valid card number. You may have missing numbers or numbers that are out of order in your current input.",
      "ccShortInvalid": "Please enter a valid card number.",
      "ccUnknownCardType": "You've entered a card type that is not accepted. Try using a Visa, Mastercard, Discover, or American Express card.",
      "ccExpired": "Based on the date you've entered, your card has expired and cannot be charged.",
      "ccPrematureExpiration": "You've entered a card that expires before your payment date. Please use a card that expires after {{payMonth}}/{{payYear}}.",
      "ccIsExpired": "This card has expired.",
      "ccExpirationInvalid": "The expiration date is not valid.",
      "ccInvalidLength": "Must be a {{validLength}}-digit number.",
      "genericRequired": "Please complete this field to continue.",
      "fieldRequired": "This field is required.",
      "genericCheckboxRequired": "Please read the disclaimer and check this box to continue.",
      "guestPayNotAvailable": "Guest pay is currently unavailable. Please make an account to proceed.",
      "invalidRoutingNumber": "The routing number you've entered is not valid.",
      "minimumAccountNumber": "Account numbers must be at least 4 digits.",
      "mismatchedAccountNumber": "The account numbers must match.",
      "unableToReset": "We are unable to reset your password. Make sure you are using the most recent Recover Password link in your email.",
      "paymentProcessingError": "We are unable to process your payment. Please contact Patientco at 1-844-422-4779, to complete your payment.",
      "paymentProcessingErrorApplePay": "We are unable to process your payment. Please edit your payment method and try again.",
      "paymentInvalidCardInformation": "The card information you inputted, is invalid. Please review the Card Number and Expiration for your payment method.",
      "paymentCardDeclined": "We are unable to process your payment due to a declined card. Please edit your payment method and try again.",
      "paymentDuplicatePayment": "It looks like you are trying to submit a duplicate payment. If this is intentional, please contact Patientco at 1-844-422-4779.",
      "confirmExpiredCard": "It looks like you're trying to pay with a card that has expired, or will expire before your scheduled payment date. Please edit your payment method and try again.",
      "confirmPrematureExpiration": "It looks like you're trying to schedule a payment after your credit card expires. Please edit your payment method and try again.",
      "phoneFormat": "It looks like you are missing some numbers in your phone number. Please enter a number that matches the format of XXX-XXX-XXXX",
      "smsEligible": "This number is not eligible to receive text messages. Please enter a valid US mobile number. If you don't have a mobile number, leave blank.",
      "termsAcceptanceRequired": "For legal reasons, we require all users to accept our Terms of Use.",
      "invalidPassword": "The Current Password you have given does not match the value we have in our system. Please check it and try again.",
      "unableToChangePassword": "We are unable to update your password at this time. Please verify your details and try again.",
      "nonexistentEmail": "There is no account associated with this email.",
      "minZipCode": "Please enter a 5 digit zip code to continue.",
      "fiveHundred": "It looks like the server encountered an error while processing your request. Please try again in a few minutes.",
      "runningOutOfCharacters": "You have used {{current}} / {{allowed}} characters",
      "reasonRequired": "Please select a message reason",
      "messageRequired": "Please enter your message to continue",
      "futureBirthdate": "You've entered a DOB that takes place in the future.",
      "incompleteBirthdate": "Please enter a full DOB (MM/DD/YYYY).",
      "invalidDate": "Date doesn't exist.",
      "adultRequired": "You must be at least 18 years of age to continue.",
      "unknown": "An unknown error occurred. Try again. If you continue to have problems, please contact Patientco at 1-844-422-4779.",
      "paymentFormProcessingError": "We are unable to add your payment method. Please contact Patientco at 1-844-422-4779.",
      "paymentFormInvalidCardInformation": "Your card information appears to be invalid. Please review the Card Number and Expiration for your payment method.",
      "ssnFormat": "It looks like you are missing some numbers in your social security number. Please enter a number that matches the format of XXX-XX-XXXX",
      "poBoxNotAllowed": "We do not allow PO Boxes at this time.",
      "goToVendorErrorMessage": "An error occurred while attempting to take you to {{financedBy}}.",
      "tooManyFiles": "You have attached too many files. Please attach 3 or fewer files.",
      "genericFileError": "An error occurred while uploading your attachment. Please try again.",
      "fileTooLarge": "One of the files you have attached is too large. Please attach a file less than 10Mb.",
      "invalidFileType": "You have attached a file with an invalid type. Please only attach jpg, jpeg, png, gif, pdf, doc, docx, or txt files.",
      "messageRequiredForAttachments": "Please add a message to submit attachments.",
      "minimumCVV": "CVV must be at least 3 digits.",
      "invalidCVV": "The CVV is not valid.",
      "paymentAgreementAcceptanceRequired": "Accepting the terms of the payment agreement is required to continue."
    },
    "accountEvents": {
      "bill": "Bill Sent",
      "collection": "collection",
      "collection-stop": "collection-stop",
      "collection-update": "collection-update",
      "collection-extraction": "collection-extraction",
      "correspondence": "Correspondence Received",
      "correspondenceOnly": "correspondenceOnly",
      "message": "Message Sent: {{message}}",
      "changeOfAddress": "Address Changed",
      "payment": "Payment Made",
      "paymentPlan": "Payment Scheduled",
      "returnMail": "Returned Mail",
      "reversePayment": "Refund Processed",
      "balanceUpdate": "Balance Updated",
      "voidedPayment": "Payment Voided",
      "declinedPayment": "Payment Declined",
      "canceledPayment": "Payment Canceled",
      "voidedPaymentPlan": "Payment Plan Voided",
      "canceledPaymentPlan": "Payment Plan Canceled"
    },
    "transworld": {
      "clientRefNum": "Client Reference #",
      "clientRefNumRequired": "Please enter the Client Reference # at the top right section of your bill.",
      "allNumericlientRefNum": "Try entering the Client Reference # printed on your bill. It's located in the top right section of your bill."
    },
    "fullPageNotifications": {
      "header": {
        "thankYou": "Thank you!"
      },
      "subheader": {
        "emailVerified": "Your email address has been verified.",
        "phoneVerified": "Your phone number has been verified."
      },
      "message": {
        "welcome": "We're happy to have you here! You've joined a community of 2 million consumers who are taking control of their healthcare expenses.",
        "welcomeBranded": "We're happy to have you here!"
      }
    },
    "whitelabel": {
      "landing": {
        "title": "PatientWallet | Pay Your Bill",
        "marketingBlurb": "Welcome to your PatientWallet<sup>&reg;</sup>. Manage your family’s bills all in one place and access flexible payment options that fit your budget."
      },
      "dialogs": {
        "thanksAndComeBack": "We look forward to having you back!",
        "welcome": "Welcome to your PatientWallet<sup>&reg;</sup>"
      },
      "contact": {
        "help": {
          "lostBill": "I lost my bill"
        },
        "lostBill": {
          "header": "Let's help you find your bill.",
          "reachOut": "Please reach out to us directly at"
        }
      },
      "confirmPhone": {
        "explanation": "You will receive a text message with a unique code to verify your mobile phone number.",
        "additionalInfo": "By verifying your phone number, you agree to allow Patientco to send you periodic text messages on behalf of your provider for any account-related activity. Patientco may use an automated system to send you electronic communications including text, phone, or email. Patientco does not have a separate charge for this service; however, subject to the terms and conditions of your mobile carrier, message and data rates may apply. By providing your consent to participate in this program, you approve any such charges from your mobile carrier. You may opt out of this program at any time by emailing Patientco at support@patientco.com."
      },
      "errors": {
        "scodeRequired": "Please enter the SecureHealthCode located in the top right section of your bill.",
        "loginPasswordRequired": "Please enter your account password to log in to PatientWallet."
      }
    },
    "verification": {
      "headerText": "Verify Email",
      "submitButtonText": "Verify",
      "submittingButtonText": "Verifying...",
      "explanation": "For improved security, we need you to verify your email address. We just sent a verification code to <strong class=\"fs-block\">{{email}}</strong>. Please check your email and enter the 6 digit code below.",
      "emailNotSent": "We were unable to send the verification email. Please try again.",
      "successHeader": "Verified!",
      "successSubheader": "You have successfully verified your email address and created your PatientWallet<sup>&reg;</sup>.",
      "emailSent": "Code has been sent.",
      "codeInvalid": "That code was invalid or expired. Please try again.",
      "bruteForce": "Account temporarily disabled due to too many failed attempts."
    },
    "branding": {
      "redirectingModalText": "You are now being redirected to your <span class='provider-group-name'></span> PatientWallet<sup>&reg;</sup>",
      "redirectErrorMessage": "An error occurred while attempting to redirect you to your <span class='provider-group-name'></span> PatientWallet<sup>&reg;</sup>. Please try again, and if you continue to have problems please contact your provider."
    },
    "messages": {
      "virusScan": {
        "pending": "Scanning for viruses...",
        "infected": "You cannot download this attachment because it failed an automated virus scan."
      }
    },
    "myChartSSO": {
      "error": {
        "backToMyChart": "Back to MyChart",
        "body": "Please return to MyChart and try again",
        "invalidToken": "Your session has expired",
        "header": "Oops, something went wrong"
      },
      "welcomeToPatientWallet": "Welcome to {{ providerGroupName }}'s PatientWallet",
      "checkForPatientWalletAccount": "Search",
      "checkForPatientWalletAccountPending": "Searching...",
      "patientWalletDescription": "The PatientWallet is where you'll be able to access all of your bills and make payments.<br/><br/>Let's check to see if you already have an account.",
      "enterEmail": "Enter your email address",
      "emailAlreadyLinked": "This email has already been linked to another MyChart account.",
      "verifyEmail": {
        "useDifferentEmail": "Use a different email address",
        "foundMatch": {
          "header": "Verify Email",
          "prompt": "We found a match! We just sent a verification code to:<br/><br/><b>{{ email }}</b><br/><br/>Check your email and enter the 6 digit code below.",
          "success": {
            "header": "Verified!",
            "prompt": "You can now access your PatientWallet directly through MyChart."
          }
        },
        "noMatch": {
          "header": "Set Up Your PatientWallet",
          "prompt": "It looks like you don't have a PatientWallet yet. That's okay, we can set one up for you. We just sent a code to:<br/><br/><b>{{ email }}</b><br/><br/>Check your email and enter the 6 digit code below.",
          "success": {
            "header": "You're all set!",
            "prompt": "You now have a new PatientWallet account that you can access directly through MyChart."
          }
        },
        "action": "Verify",
        "actionPending": "Verifying...",
        "resend": "Resend"
      },
      "finishRegistration": {
        "header": "Welcome Back!",
        "prompt": "It looks like you've accessed your PatientWallet before through MyChart. Please finish setting up your account by adding your phone number and a password.",
        "action": "Save",
        "success": {
          "header": "Success!",
          "prompt": "Your account has been updated."
        }
      }
    },
    "hiddenHeaders": {
      "providers": "Providers",
      "newBill": "New Bill",
      "accounts": "Accounts",
      "messages": "Messages",
      "inputMessage": "Input Message",
      "paymentOptions": "Payment Options",
      "paymentStage": "Payment Stage"
    },
    "breadCrumbs": {
      "providers": "Providers",
      "accounts": "Accounts"
    }
  });
  $translateProvider.translations("es", {
    "dashboard": {
      "dashboard": "Proveedores",
      "home": "Inicio",
      "failedToLoadProvider": {
        "header": "No se Puede Cargar",
        "body": "Se produjo un error al intentar cargar más información para este proveedor. Inténtalo de nuevo.",
        "button": "Atrás"
      },
      "zeroStateTitle": "No hay proveedores",
      "zeroStateBlurb": "Ingrese los detalles de su factura más reciente para acceder a los saldos actualizados, la actividad de facturación pasada y los detalles de la transacción entre sus proveedores de atención médica",
      "zeroStateTitleMyChartSSO": "Sin facturas",
      "zeroStateBlurbMyChartSSO": "No hay facturas disponibles para usted en este momento.",
      "argsDashboard": "{{name}}'s Proveedores",
      "argsDashboardEndsWithS": "{{name}}' Proveedores",
      "possessivePatientWallet": "{{name}}'s PatientWallet",
      "possessivePatientWalletEndsWithS": "{{name}}' PatientWallet",
      "yourPatientWallet": "Tu PatientWallet"
    },
    "encounterLinking": {
      "linkableAccounts": "Hemos encontrado cuentas adicionales para agregar a su PatientWallet<sup>&reg;</sup>. <a href=\"\" class=\"link inline\"> Verificar cuentas </a>",
      "proactiveLinkableAccounts": "¿Desea que agreguemos automáticamente las cuentas de {{providerGroupList}} a su PatientWallet<sup>&reg;</sup>? <a href=\"\" class=\"link inline\"> Verificar cuentas </a>",
      "experiencedLinkableAccounts": "Tiene más cuentas para agregar a su PatientWallet<sup>&reg;</sup>. <a href=\"\" class=\"link inline\"> Verificar cuentas </a>",
      "verifyInformation": "Verificar información",
      "verifyingInformation": "Información de verificación...",
      "whichPatient": "¿A quién le gustaría verificar?",
      "verifyAcctTitle": "Información de verificación para <br /> {{linkingName}}",
      "verifyAcctSubtitlePatient": "Ingrese los campos de seguridad a continuación para agregar {{patientName}} cuentas de {{providerGroup}}.",
      "verifyAcctSubtitleGuarantor": "Ingrese su información a continuación para agregar {{patientName}} cuentas de {{providerGroup}}.",
      "birthdatePlaceholder": "Fecha de nacimiento (MM / DD / YYYY)",
      "SSNPlaceholder": "últimos cuatro dígitos del número de seguro social",
      "ssnHelpInfo": "<b> Nota: </b> Si agrega cuentas para un infante, use el SSN del garante",
      "moreInfo": "Cómo funciona este trabajo?",
      "verificationFailed": "La información que ha ingresado no coincide con nuestros registros para {{patientName}}. Inténtelo de nuevo.",
      "verificationBlocked": "Ha intentado agregar {{patientName}} cuenta demasiadas veces. Por razones de seguridad, su capacidad para agregar esta cuenta se ha deshabilitado temporalmente",
      "verificationHeader": "Cuenta agregada con éxito",
      "verificationHeaderPlural": "Cuentas agregadas con éxito",
      "verificationSubheader": "En el futuro, agregaremos automáticamente {{patientName}} facturas de {{providerGroup}} a su PatientWallet<sup>&reg;</sup>.",
      "proactiveExperiencedVerificationSubheader": "{{patientName}} no tiene cuentas anteriores para agregar, pero agregaremos automáticamente sus cuentas futuras para {{providerGroup}} a su PatientWallet<sup>&reg;</sup>.",
      "incompleteSSN": "Parece que le faltan unos pocos dígitos. Por favor ingrese los últimos cuatro números de su número de seguro social.",
      "proactiveVerificationHeader": "{{PatientName}} verificado exitosamente.",
      "close": "Cerrar",
      "continueToPay": "Continue to Bill"
    },
    "firstComm": {
      "optionsHeader": "Verificar información",
      "verifyEmailHeader": "¡Revise su correo electrónico!",
      "verifySmsHeader": "¡Revise su teléfono!",
      "birthdatePlaceholder": "Fecha de nacimiento (MM / DD / YYYY)",
      "SSNPlaceholder": "últimos cuatro dígitos del número de seguro social",
      "incompleteSSN": "Parece que le faltan unos pocos dígitos. Ingrese los últimos cuatro números de su SSN.",
      "verifyViaEmailOption": "Envíeme un código por correo electrónico ({{emailAddress}})",
      "verifyViaSmsOption": "Envíeme un código de texto ({{phoneNumber}})",
      "verifyViaPdiv": "Ingrese sus datos demográficos",
      "sendAgainButtonText": "No recibí un código",
      "sendingCodeButtonText": "Enviando...",
      "back": "Atrás",
      "submitText": "Siguiente",
      "submittingText": "Comprobando...",
      "successHeader": "Ha sido verificado!",
      "codeNotSent": "Hubo un problema al enviar ese código. Vuelva a intentarlo.",
      "codeSent": "El código ha sido enviado.",
      "codeInvalid": "El código no era válido o caducó. Inténtelo de nuevo.",
      "pdivInvalid": "Uno o más campos no coinciden con nuestros registros. Si cree que su información es correcta, comuníquese con su proveedor.",
      "bruteForce": "La cuenta se deshabilitó temporalmente debido a demasiados intentos fallidos.",
      "missingGuarantorName": "Paciente"
    },
    "firstBill": {
      "optionsSubheader": "{{providerName}} necesita verificar su identidad antes de que pueda acceder a su factura",
      "verifyEmailSubheader": "Ingrese el código que le enviamos a su dirección de correo electrónico ({{emailAddress}}) para acceder a su factura de {{providerName}}.",
      "verifySmsSubheader": "Ingrese el código que enviamos a su dispositivo móvil por mensaje de texto ({{phoneNumber}}) para acceder a su factura de {{providerName}}.",
      "verifyPdivHeader": "Ingrese los campos de seguridad a continuación para acceder a su factura de {{providerName}}",
      "successSubheader": "Haga clic a continuación para ver su factura.",
      "successModalButton": "Ver factura",
      "unableToAuth": "No podemos autenticar su cuenta en este momento. Su factura llegará pronto por correo."
    },
    "firstEstimate": {
      "optionsSubheader": "{{providerName}} necesita verificar su identidad antes de que pueda acceder a su estimación",
      "verifyEmailSubheader": "Ingrese el código que le enviamos a su dirección de correo electrónico ({{emailAddress}}) para acceder a su estimación de {{providerName}}.",
      "verifySmsSubheader": "Ingrese el código que enviamos a su dispositivo móvil por mensaje de texto ({{phoneNumber}}) para acceder a su estimación de {{providerName}}.",
      "verifyPdivHeader": "Ingrese los campos de seguridad a continuación para acceder a su estimación de {{providerName}}",
      "successSubheader": "Haga clic a continuación para ver su estimación.",
      "successModalButton": "Ver estimación",
      "unableToAuth": "No podemos autenticar su cuenta en este momento. Su estimación debería llegar pronto por correo."
    },
    "confirmPhone": {
      "header": "Registro completo de la cuenta",
      "numberSubheader": "Verifique su número de teléfono móvil",
      "codeSubheader": "Ingrese el código que enviamos a su dispositivo móvil por SMS",
      "submitButtonText": "Enviar código",
      "submittingButtonText": "Enviando...",
      "verifyButtonText": "Verificar",
      "verifyingButtonText": "Verificando...",
      "sendAgainButtonText": "No recibí un código",
      "successHeader": "Gracias por verificar su número de teléfono",
      "learnMore": "Más información",
      "hide": "Ocultar",
      "additionalInfo": "Al verificar su número de teléfono, usted acepta que Patientco le envíe mensajes de texto periódicos para cualquier actividad relacionada con la cuenta. Patientco puede usar un sistema automatizado para enviarle comunicaciones electrónicas que incluyen texto, teléfono o correo electrónico. Patientco no tiene un cargo por separado para este servicio; sin embargo, sujeto a los términos y condiciones de su operador de telefonía móvil, pueden aplicarse tarifas de mensajes y datos. Al proporcionar su consentimiento para participar en este programa, usted aprueba cualquier cargo de su proveedor de telefonía móvil. Puede optar por no participar en este programa en cualquier momento enviando un correo electrónico a Patientco a support@patientco.com.",
      "explanation": "Patientco le enviará un mensaje de texto con un código único para verificar su número de teléfono móvil.",
      "errors": {
        "sentAgain": "¡Lo siento! Te enviamos otro código.",
        "codeNotSent": "Hubo un problema al enviar ese código. Por favor, inténtelo de nuevo.",
        "codeInvalid": "Ese código no era válido o expiró Vuelva a intentarlo."
      }
    },
    "confirmEmail": {
      "header": "Verificar dirección de correo electrónico",
      "submitButtonText": "Enviar correo electrónico",
      "submittingButtonText": "Enviando...",
      "explanation": "¿Es correcta la dirección de correo electrónico? De lo contrario, corríjalo antes de hacer clic en el botón \"Enviar correo electrónico\" para actualizar su cuenta",
      "successHeader": "Correo electrónico de verificación enviado",
      "emailNotSent": "Hubo un problema al enviar ese correo electrónico. Inténtelo de nuevo."
    },
    "receipt": {
      "receipt": "Recibo",
      "argPaidCallout": "<b> {{amount}} </b> Pagado",
      "argScheduledCallOut": "<b> {{amount}} </b> Programado",
      "argAuthorizedCallOut": "<b>{{amount}}</b> Autorizado",
      "argRemainingCallOut": "<b> {{amount}} </b> Restante",
      "transactionIdArg": "ID de transacción # {{transactionId}}",
      "balancePayment": "Pago de saldo",
      "argDeclinedCallout": "<b> {{amount}} </b> Rechazado",
      "argCanceledCallout": "<b> {{amount}} </b> Cancelado",
      "confirmCancelDialog": "¿Está seguro de que desea <br /> cancelar este pago?",
      "cancelPaymentDesc": "{{amount}} programado para {{date}}",
      "fullRefund": "Reembolso completo",
      "partialRefund": "Reembolso parcial",
      "chargeback": "Devolución de cargo",
      "failedECheck": "Failed eCheck",
      "bouncedCheck": "Bounce Compruebe",
      "paymentMethodUpdated": "Se ha actualizado el método de pago.",
      "paymentMethodHeld": "No hemos podido procesar un pago. Seleccione otro método de pago y vuelva a intentarlo.",
      "updateMethodScheduledPlanConfirmDialog": "Los pagos restantes en su plan se actualizarán para usar {{method}}.",
      "updateMethodHeldPlanConfirmDialog": "Los pagos restantes en su plan se actualizarán para usar {{method}}. <br /> <br/> Todos los pagos en el plan que fueron rechazados o retenidos previamente se procesarán usando el nuevo método de pago.",
      "printingNotSupportedHeader": "Impresión no disponible",
      "printingNotSupportedContent": "No pudimos activar la función de impresión de su navegador. Si su navegador admite la impresión, intente utilizar la acción de impresión incorporada. De lo contrario, haga clic en {{viewBill}} para descargar un PDF de su factura.",
      "paidWithApplePayDesc": "Pagado con Apple Pay",
      "billTo": "Cobrar a:",
      "methodChanged": "Método de pago cambiado."
    },
    "newbill": {
      "whichAccount": "¿Qué factura le gustaría pagar?",
      "accountDue": "<b> {{providerName}} </b> <br/> Cuenta # {{accountNumber}} | {{amountDue}} due",
      "accountPastDue": "<b> {{providerName}} </b> <br/> Cuenta # {{accountNumber}} | {{amountDue}} vencido"
    },
    "planReceipt": {
      "paymentPlanUpdated": "Plan de pago ha sido actualizado",
      "paymentPlanCreated": "Plan de pago ha sido creado",
      "printingNotSupportedHeader": "Impresión no disponible",
      "printingNotSupportedContent": "No pudimos activar la función de impresión de su navegador. Si su navegador admite la impresión, intente utilizar la acción de impresión incorporada. De lo contrario, haga clic en {{viewBill}} para descargar un PDF de su factura.",
      "messageProviderForQuestions": "Comuníquese con su proveedor si tiene alguna pregunta o si desea realizar algún cambio en su plan de pago."
    },
    "message": {
      "message": "Mensaje",
      "plural": "Mensajes",
      "newMessage": "Nuevo Mensaje",
      "messageSent": "¡Su mensaje ha sido enviado!",
      "argsMessages": "Mensajes de {{name}}",
      "argsMessagesEndsWithS": "Mensajes de {{name}}",
      "createAreaPlaceholder": "Comience a escribir su respuesta...",
      "whoToContact": "¿A quién le gustaría contactar?",
      "whichAccount": "¿Con qué cuenta necesita ayuda?",
      "noProvidersToMessage": "Su PatientWallet<sup>&reg;</sup> está actualmente vacía. Agregue una nueva factura para comenzar.",
      "startMessagePlaceholder": "Comience a escribir su mensaje...",
      "messageClosedByProviderDialog": "Este hilo de mensajes está cerrado.",
      "startNewMessageDialog": "Si desea iniciar otro hilo de mensajes, ",
      "clickHereWithPeriod": "haga clic aquí.",
      "argProviderCantMessage": "{{name}} no admite mensajes a través de Patientco. Si desea comunicarse con su proveedor, llame a {{billingPhoneNumber}}. Nos disculpamos por cualquier inconveniente.",
      "reasons": {
        "default": "Seleccionar un motivo",
        "specificCharge": "Cuestionar un cargo especifico",
        "duplicate": "Cargos/Facturas duplicadas",
        "paymentPlan": "Configurar un plan de pago",
        "missingPayments": "Consultar acerca de pagos faltantes",
        "other": "Otro",
        "updateInsurance": "Actualizar mi información",
        "insuranceQuestion": "Tengo una pregunta sobre el seguro",
        "financialAssistance": "Solicitar ayuda financiera",
        "itemizedBill": "Solicitar una factura detallada",
        "estimate": "Pregunta sobre estimación"
      },
      "zeroStateTitle": "Sin mensajes",
      "zeroStateBlurb": "Comuníquese de manera segura con todos sus proveedores de atención médica en un solo lugar. Haz una pregunta sobre tu factura, configura un plan de pago o simplemente dar las gracias",
      "reason": "Razón",
      "provider": "Proveedor",
      "selectProvider": "Seleccione un proveedor",
      "account": "Cuenta",
      "selectAccount": "Seleccione una cuenta",
      "messagingDisabled": "La mensajería está deshabilitada para su proveedor.",
      "messagingDisabledPhoneNumber": "Favor de contactarlos al "
    },
    "notification": {
      "notification": "Notificación",
      "plural": "Notificaciones",
      "zeroStateTitle": "Sin notificaciones",
      "noLongerAvailable": "Esta notificación ya no está disponible."
    },
    "login": {
      "minCharactersRule": "8 caracteres",
      "upperCaseRule": "1 letra mayúscula",
      "digitRule": "1 número",
      "nextButton": "Siguiente",
      "forgotPasswordQuestion": "¿Olvidó su contraseña?",
      "forgotPasswordQuestionSubcontent": "",
      "forgotPasswordSentDialog": "¡Genial! Hemos enviado ayuda a <br /> <b> {{email}} </b>",
      "forgotPasswordMethodHeader": "¿Cómo quieres restablecer tu contraseña?",
      "forgotPasswordMethodEmailButton": "Enviarme un correo electrónico ({{email}}))",
      "forgotPasswordMethodSmsButton": "Texto me ({{phone}})",
      "forgotPasswordMethodCode": "Por favor ingrese su código de verificación",
      "forgotPasswordCheckEmailTitle": "Revise su correo electrónico y haga clic en el enlace",
      "forgotPasswordEmailSentTryAgainButton": "Intente nuevamente",
      "forgotPasswordMethodSendAgainButton": "No recibí un código",
      "resetPasswordHeader": "Cree su nueva contraseña .",
      "resetPasswordCompleteDialog": "Ahora puede iniciar sesión con su correo electrónico y nueva contraseña.",
      "resetPasswordCheckEmailMessage": "Acabamos de enviar un correo electrónico con un enlace para restablecer la contraseña a <br /> <b> {{email}} </b>. <br /> <br /> Si no lo ve en su bandeja de entrada, asegúrese de revisar su carpeta de correo no deseado."
    },
    "setting": {
      "menu": {
        "contact": "Información Personal",
        "savedPaymentMethods": "Métodos de pago guardados",
        "accountManagement": "Administración de cuentas"
      },
      "setting": "Configuración",
      "plural": "Configuración",
      "argsSettings": "{{name}}'s Configuración",
      "argsSettingsEndsWithS": "{{name}}' Configuración",
      "ebillDialog": "Envíeme un correo electrónico cuando se agreguen nuevas facturas a mi cuenta.",
      "smsDialog": "Envíeme un mensaje de texto cuando se agreguen nuevas facturas a mi cuenta.",
      "argMethodDeleted": "{{method}} <br /> se ha eliminado",
      "deleteMethodArg": "Delete {{detail}}",
      "confirmDeleteDialog": "¿Está seguro de que desea eliminar este pago método?",
      "passwordChangedDialog": "Su contraseña se ha cambiado correctamente.",
      "unremovableMethodHelp": "Este el método de pago se utiliza para realizar un pago programado <br /> y no se puede eliminar.",
      "nonDeactivateableUserHelp": "No se puede cancelar ivate su cuenta porque <br/> usted tiene uno o más pagos programados.",
      "modals": {
        "email": {
          "header": "Comunicaciones por correo electrónico",
          "content": "Al habilitar las notificaciones por correo electrónico, le otorga a Patientco permiso para enviarle periódicamente por correo electrónico las nuevas facturas o recordatorios sobre las facturas con vencimiento pendiente. fechas. La notificación por correo electrónico es una función opcional de Patientco que se deshabilita hasta que modifique la configuración de notificación en la pestaña \"Configuración\" o en la página de registro. Puede optar por habilitar o deshabilitar esta función en cualquier momento, pero los cambios pueden demorar hasta 48 horas para entrar en vigencia. Patientco se reserva el derecho de interrumpir las notificaciones de la factura electrónica en cualquier momento, a nuestra entera discreción. Su información médica protegida (PHI) no se incluirá en ningún correo electrónico. Su PHI solo se puede ver iniciando sesión en Patientco usando su dirección de correo electrónico registrada."
        },
        "sms": {
          "header": "Comunicaciones SMS",
          "content": "Al habilitar las notificaciones de mensajes de texto, usted acepta que Patientco le envíe mensajes de texto periódicos para cualquier actividad relacionada con la cuenta. Patientco puede usar un sistema automatizado para enviarle comunicaciones electrónicas que incluyen texto, teléfono o correo electrónico. Patientco no tiene un cargo por separado para este servicio; sin embargo, sujeto a los términos y condiciones de su operador de telefonía móvil, pueden aplicarse tarifas de mensajes y datos. Al proporcionar su consentimiento para participar en este programa, usted aprueba cualquier cargo de su proveedor de telefonía móvil. Puede optar por no participar en este programa en cualquier momento en la pestaña \"Configuración\" en su PatientWallet<sup>&reg;</sup>."
        }
      },
      "methodAdded": "{{method}} <br/> se ha agregado"
    },
    "landing": {
      "title": "Patientco | Pague su factura",
      "enterBills": "Ingrese los detalles únicos de su factura",
      "marketingBlurb": "Bienvenido a PatientWallet<sup>&reg;</sup>! Nos hemos asociado con su proveedor de atención médica para brindarle la experiencia de pago más simple y segura posible.",
      "needHelpHeader": "¿Necesita ayuda para encontrar su factura?",
      "needHelpContent": "Haga clic en las casillas blancas proporcionadas para ingresar su SecureHealthCode y Balance Due"
    },
    "providersDashboard": {
      "totalAmountDue": "Monto Total Adeudado",
      "account": "Cuenta",
      "accounts": "Cuentas",
      "pastDue": "Vencido",
      "noBills": "Sin facturas",
      "noBillsDescriptionShort": "Cuando reciba nuevas facturas, aparecerán aquí.",
      "noBillsDescriptionLong": "Cuando reciba nuevas facturas, aparecerán aquí. Si ha recibido una factura y no la ve en la lista, <a @click=\"findBillBottomSheet = true\" class=\"find-bill-bottom-sheet-link\"><u>haga clic aquí</u></a> para buscar su factura."
    },
    "accountsSummaryAccountCard": {
      "accountNumber": "Cuenta #...",
      "dueBy": "Debido por",
      "bill": "Factura",
      "bills": "Facturas",
      "estimate": "Estimación",
      "estimates": "Estimaciónes"
    },
    "dbuUpdate": {
      "lastStatementBalance": "Último Balance de Declaración",
      "balanceIncrease": "Aumento de Saldo",
      "balanceDecrease": "Disminución de saldo",
      "bottomSheetHeaderIncrease": "El saldo de su cuenta ha aumentado desde su último estado de cuenta.",
      "bottomSheetHeaderDecrease": "El saldo de su cuenta ha disminuido desde su último estado de cuenta.",
      "bottomSheetBody": "Desde su último estado de cuenta ha habido nueva actividad en su cuenta. En la mayoría de los casos, el saldo actualizado refleja nuevos cargos, pagos o contribuciones al seguro."
    },
    "contact": {
      "help": {
        "header": "Necesito ayuda con:",
        "myBill": "Comprender mi factura",
        "lostBill": "Perdí mi factura de Patientco",
        "loggingIn": "Iniciar sesión",
        "itemizedBill": "Necesito una factura detallada",
        "resetPassword": "Restablecer mi contraseña"
      },
      "questionAbout": {
        "header": "Yo tiene una pregunta sobre: ​​",
        "reasons": {
          "specificCharge": "Un cargo en mi factura",
          "duplicate": "Un cargo o factura duplicada",
          "paymentPlan": "Creación de un plan de pago",
          "missingPayments": "Pagos faltantes",
          "other": "Otro",
          "updateInsurance": "Información de actualización",
          "insuranceQuestion": "Seguro",
          "financialAssistance": "Financiero asistencia",
          "itemizedBill": "Solicitando una factura detallada",
          "estimate": "La estimación"
        }
      },
      "rightPlace": {
        "header": "Vamos a llevarlo al lugar correcto",
        "enterEmail": "Ingrese su dirección de correo electrónico:",
        "enterBillDetails": "Ingrese los detalles de su factura:"
      },
      "almostThere": {
        "header": "Casi allí...",
        "password": "Cree una contraseña:",
        "login": "Inicie sesión en su cuenta:"
      }
    },
    "chat": {
      "paymentPlans": {
        "selectProvider": "Seleccione un proveedor para ver las cuentas elegibles:",
        "selectAccount": "Seleccione una cuenta para ver las opciones de planes disponibles:",
        "noProviders": "Su PatientWallet está actualmente vacía. Agregue una nueva factura para ver las opciones de planes disponibles."
      }
    },
    "actions": {
      "pay": "Pagar",
      "makePayment": "Realizar un pago",
      "viewPaymentOptions": "Ver opciones de pago",
      "viewEstimateDetails": "Ver detalles de la estimación",
      "payThisVisit": "Pagar esta visita",
      "viewMyBill": "Ver factura",
      "viewBill": "Ver factura",
      "viewLastStatement": "Ver última declaración",
      "viewPlan": "Ver Plan",
      "viewAccounts": "Ver cuentas",
      "viewAccount": "Ver cuenta",
      "viewMessage": "Ver mensaje",
      "viewEstimate": "Ver estimación",
      "viewDashboard": "Ver tablero",
      "view": "Ver",
      "edit": "Editar",
      "verify": "Verificar",
      "verifying": "Verificar...",
      "submit": "Enviar",
      "submitting": "Enviar...",
      "messageProvider": "Enviar Mensajes a Proveedor",
      "updatePaymentForm": "Cambiar el método de pago",
      "createMessage": "Crear nuevo mensaje",
      "continue": "Continuar",
      "continueSingle": "Crear un Pago único",
      "continuePlan": "Crear un plan de pago",
      "setUpAutoPayPlan": "Configurar un plan de pago automático",
      "mergePlan": "Actualizar Plan de Pago",
      "processPayment": "Procesar pago",
      "retryProcessPayment": "Reintentar proceso",
      "processPaymentFuture": "Programar pago",
      "createAccount": "Crear cuenta",
      "creatingAccount": "Crear cuenta...",
      "login": "Iniciar sesión",
      "loggingIn": "Iniciar sesión... .",
      "logout": "Cerrar sesión",
      "payNewBill": "Pagar nueva factura",
      "payBill": "Pagar factura",
      "goToVendor": "Ir a {{financedBy}}",
      "payAsGuest": "Pagar como invitado",
      "sendingToGuestPay": "Enviar a pago de invitado",
      "payAnotherBill": "Pagar otra factura",
      "openReceipt": "Ver recibo",
      "findBill": "Encontrar factura",
      "findingBill": "Encontrar factura...",
      "needHelp": "¿Necesita ayuda?",
      "contactUs": "Contáctenos",
      "learnMore": "Obtenga más información",
      "goToDashboard": "Ver panel",
      "open": "Abrir",
      "sendMessage": "Enviar Mensaje",
      "send": "ENVIAR",
      "sending": "Enviando mensaje...",
      "attachFile": "Adjuntar documentos",
      "printReceipt": "Imprimir recibo",
      "printPlan": "Imprimir detalles del plan",
      "back": "Volver",
      "backToSSO": "Volver a {{ friendlySSOEnvName }}",
      "backToDashboard": "Volver a proveedores",
      "backToMessages": "Volver a los mensajes",
      "backToArg": "Volver a {{properNoun}}",
      "deleteCard": "Eliminar tarjeta",
      "deleteECheck": "Eliminar eCheck",
      "addNewMethod": "Agregar nuevo método",
      "changePassword": "Cambiar contraseña",
      "deactivateAccount": "Desactivar Cuenta",
      "confirmPassword": "Confirmar contraseña",
      "close": "Cerrar",
      "cancel": "Cancelar",
      "saveChanges": "Guardar cambios",
      "forgotPassword": "¿Olvidó su contraseña?",
      "retrievingResetOptions": "Recuperando opciones de restablecimiento ...",
      "retrievePassword": "Recuperar contraseña",
      "resetPassword": "Restablecer contraseña",
      "visitWebsite": "Visitar sitio web",
      "cancelPayment": "Cancelar pago",
      "viewOlderActivity": "Ver Actividad anterior",
      "stayLoggedIn": "Manténgase conectado",
      "sendFeedback": "Enviar comentarios",
      "sendingFeedback": "Enviando...",
      "viewZeroBalanceAccts": "Ver {{count}} Cuentas pagadas",
      "enterSHCTooltip": "Ingrese el SecureHealthCode que está impreso en su factura",
      "enterAmountTooltip": "Ingrese el El saldo total adeudado que está impreso en su factura, incluso si tiene la intención de pagar una cantidad diferente",
      "confirmPhoneNumber": "Verifique su número de teléfono móvil",
      "confirmPhoneNumberNew": {
        "message": "Termine de configurar su PatientWallet <a>verificando su número de teléfono móvil</a>."
      },
      "confirmEmail": "Haga clic aquí para verificar su dirección de correo electrónico: {{email}}",
      "confirmEmailnew": {
        "message": "Termine de configurar su PatientWallet <a>verificando su dirección de correo electrónico</a>."
      },
      "verifyFoundAccounts": {
        "message": "Encontramos otras cuentas que pueden pertenecerte. <a>Verifique que sean suyos para agregarlos a su PatientWallet</a>."
      },
      "processPaymentForm": "Guardar Método de pago",
      "retryProcessPaymentForm": "Volver a intentar método de pago",
      "confirmAndProcess": "Confirmar y procesar",
      "accept": "Aceptar",
      "switchLanguage": "Switch to English",
      "viewPlanDetails": "Ver detalles del plan",
      "resend": "Reenviar",
      "viewStatmentPDF": "Ver declaración PDF",
      "watchStatementOverview": "Ver descripción general de la declaración",
      "change": "Cambiar",
      "addPaymentMethod": "Añadir método de pago"
    },
    "statusChips": {
      "providerInactive": "Proveedor Inactivo",
      "badDebt": "Agencia Externa",
      "pending": "Pendiente",
      "dueDate": "Debido Por {{ date }}",
      "paymentPlanInProgress": "Plan de pagos",
      "paymentPlanHeld": "Plan de pagos impedido",
      "negativeBalance": "Reembolso elegible",
      "pastDue": "Vencido",
      "void": "Vacío"
    },
    "accountStatusSheets": {
      "badDebtHeader": "Agencia Externa",
      "badDebtBody": "Su proveedor ya no acepta pagos a través de PatientWallet porque su cuenta ahora está siendo administrada por una compañía diferente. En la mayoría de los casos, esto se debe a que un saldo no se ha pagado durante un período prolongado. Comuníquese con la oficina de facturación de su proveedor para obtener instrucciones sobre qué hacer a continuación.",
      "refundEligibleHeader": "Refund Eligible",
      "refundEligibleBody": "En la mayoría de los casos, esto significa que ha pagado más de lo que debe. Comuníquese con la oficina de facturación de su proveedor para obtener instrucciones sobre cómo iniciar un reembolso.",
      "providerInactiveHeader": "Reembolso elegible",
      "providerInactiveBody": "Su proveedor ya no acepta pagos a través de PatientWallet. Comuníquese con la oficina de facturación de su proveedor para obtener instrucciones sobre cómo realizar pagos a esta cuenta."
    },
    "labels": {
      "providerName": "Nombre del proveedor",
      "providerLocation": "Ubicación del proveedor",
      "argAccount": "{{num}}&nbsp;Cuenta",
      "argAccounts": "{{num}}&nbsp;Cuentas",
      "argNumPastDue": "{{num}}&nbsp;Pasado&nbsp;Due",
      "argNumAccountsPastDue": "{{num}}&nbsp;Cuentas&nbsp;Pasado&nbsp;Due",
      "argNumAccountPastDue": "{{num}}&nbsp;Account&nbsp;Pasado&nbsp;Due",
      "accountNumber": "Número de cuenta",
      "accountNumberConfirm": "Confirmar número de cuenta",
      "guarantorName": "Nombre del garante",
      "name": "Nombre",
      "firstName": "Nombre",
      "lastName": "Apellido",
      "email": "Dirección de correo electrónico",
      "phone": "Número de teléfono",
      "password": "Contraseña",
      "passwordConfirm": "Confirmar contraseña",
      "statementSent": "Fecha de facturación",
      "balancDue": "Fecha de vencimiento",
      "dueDate": "Fecha de vencimiento",
      "dueArg": "Fecha de vencimiento {{date}}",
      "argDue": "{{amount | currency}} vencido",
      "pastDue": "Vencido vencido",
      "billSummary": "Resumen de la factura",
      "costBreakdown": "Desglose de los costos",
      "nameOnCard": "Nombre en la tarjeta",
      "cardNumber": "Número de tarjeta",
      "cvvFormat": "CVV",
      "cardExpirationDate": "Fecha de caducidad (MM/YY)",
      "expirationFormat": "MM / YY",
      "routingNumber": "Número de ruta",
      "accountHolderName": "Nombre del titular de la cuenta",
      "accountNumberArg": "Número de cuenta {{number}}",
      "address": "Dirección",
      "address2": "Línea de dirección 2 (opcional)",
      "city": "Ciudad",
      "state": "Estado",
      "zip": "Código postal",
      "date": "Fecha",
      "status": "Estado",
      "description": "Descripción",
      "amount": "Cantidad",
      "secureCodeOnBill": "SecureHealthCode en la Factura",
      "balanceOnBill": "Saldo Total Adeudado",
      "secureCode": "SecureHealthCode",
      "totalBalanceDue": "Saldo Total Adeudado",
      "argBalance": "{{balance}} Saldo",
      "enterUniqueDetails": "Ingrese los detalles de su nueva factura",
      "badDebt": "Remitido a una agencia externa",
      "servicedByFinancingVendor": "Reparado por {{financedBy}}",
      "noBalance": "Sin saldo adeudado",
      "pendingBalance": "Pendiente",
      "remainingBalance": "Saldo restante",
      "negativeBalance": "Comuníquese con su proveedor para obtener información sobre su saldo negativo",
      "yourBillAmount": "Cantidad de facturas",
      "billAmount": "Cantidad de facturas",
      "billDetails": "Total de la factura",
      "newBalance": "Saldo actual",
      "updating": "Actualizando...",
      "loading": "Cargando...",
      "noAccountActivity": "No hay actividad en la cuenta",
      "accountDetailsActivityHeader": "Actividad",
      "contactProvider": "Contacto del proveedor",
      "providerResources": "Recursos del proveedor",
      "needHelp": "¿Necesitas ayuda?",
      "providerAccounts": "{{providerName}} Cuentas",
      "messageDetails": "Detalles del mensaje",
      "argPaid": "{{amount}} Pagado",
      "argScheduled": "{{amount}} Programado",
      "argAuthorized": "{{amount}} Autorizado",
      "argTotal": "{{amount}} Total",
      "amountPaid": "Cantidad pagada",
      "amountAuthorized": "Monto autorizado",
      "details": "Detalles",
      "userDetails": "Detalles del usuario",
      "futurePayment": "Pago futuro",
      "createdArg": "Creado {{date}}",
      "updatedArg": "Actualizado {{date}}",
      "communicationPrefs": "Preferencias de comunicación",
      "accountManagement": "Administración de cuentas",
      "savedMethods": "Métodos de pago guardados",
      "financingMethods": "Cuentas de financiamiento",
      "noSavedMethods": "Guardado los métodos de pago aparecerán aquí.",
      "noFinancingMethods": "Actualmente no hay financiación cuenta. Consulte con su proveedor para ver si hay financiamiento disponible",
      "phoneNumber": "Teléfono móvil",
      "primaryPhone": "Teléfono principal",
      "currentPassword": "Contraseña actual",
      "newPassword": "Nueva contraseña",
      "confirmNewPassword": "Confirmar nueva contraseña",
      "submittingPayment": "Procesando pago...",
      "submittingPaymentForm": "Ahorro. ..",
      "retrievingPassword": "Recuperar contraseña...",
      "submittingPaymentFuture": "Programar pago...",
      "resettingPassword": "Restablecer contraseña...",
      "savingChanges": "Guardar cambios...",
      "acceptanceOfTerms": "Estoy de acuerdo con los <a href=\"https://www.waystar.com/patientco-terms-of-use/\" target=\"_blank\">términos de uso</a>",
      "changesSaved": "Cambios guardados",
      "changesFailed": "No se pueden guardar los cambios",
      "declinedPayment": "Pago rechazado",
      "paymentDeclined": "Pago rechazado",
      "argDeclined": "{{amount}} Rechazado",
      "canceledPayment": "Pago cancelado",
      "paymentCanceled": "Pago cancelado",
      "argCanceled": "{{amount}} Cancelado",
      "providerDisabledExplanation": "{{provider.name}} ya no acepta pagos en esta cuenta. Haga clic a continuación para ver los pagos/recibos anteriores.",
      "paymentPlanTitle": "Detalles del plan",
      "paymentPlanStatus": "Plan de pagos {{status}}",
      "verificationCode": "Código de verificación",
      "receivesEbills": "Envíeme por correo electrónico nuevas facturas y recordatorios",
      "receivesSms": "Envíeme un mensaje de texto nuevas facturas y recordatorios",
      "socialSecurityNumber": "Número de Seguro Social",
      "birthdate": "Fecha de nacimiento (MM / DD / AAAA)",
      "income": "Ingreso mensual del hogar",
      "changePassword": "¿Necesita cambiar su contraseña?",
      "deactivateAccount": "¿Necesita desactivar su cuenta?",
      "invalidPassword": "Contraseña no válida",
      "moreInfo": "Más información",
      "appointmentInfo": "Cita",
      "appointmentSummary": "Resumen de la cita",
      "appointmentDate": "Día de la cita",
      "appointmentTime": "Hora de la cita",
      "estimate": "Estimación del servicio en {{date}}",
      "estimateAmount": "Importe estimado",
      "estimatedVisitCost": "Su costo estimado",
      "estimateSummaryServiceAmount": "Costo total estimado",
      "estimateSummaryInsuranceCoverage": "Cobertura de seguro estimada",
      "estimateSummaryEstimatedCost": "Su costo estimado",
      "estimateSummaryDisclaimerHeader": "Descargo De Responsabilidad:",
      "estimateSummaryDisclaimer": "Los números anteriores son cantidades estimadas y están sujetas a cambios.",
      "estimateSummaryDisclaimerDetails": "<p>Esta estimación de buena fe muestra los costos de artículos y servicios que se esperan razonablemente para sus necesidades de atención médica para un artículo o servicio. La estimación se basa en la información conocida en el momento en que se creó la estimación y no incluye ningún costo desconocido o inesperado que pueda surgir durante el tratamiento. Podrían cobrarle más o recibir facturas adicionales si se presentan complicaciones o circunstancias especiales. Si esto sucede, la ley federal le permite disputar (apelar) la factura.</p><p>Si le facturan más de este Estimado de buena fe, tiene derecho a disputar la factura.</p><p>Puede comunicarse con el proveedor de atención médica o el centro que se indica para informarles que los cargos facturados son más altos que el Estimado de buena fe. Puede pedirles que actualicen la factura para que coincida con el Estimado de buena fe, solicitar negociar la factura o preguntar si hay asistencia financiera disponible.</p><p>También puede iniciar un proceso de resolución de disputas con el Departamento de Salud y Servicios Humanos (HHS) de EE. UU. Si elige utilizar el proceso de resolución de disputas, debe iniciar el proceso de disputa dentro de los 120 días calendario (alrededor de 4 meses) a partir de la fecha de la factura original.</p><p>Hay una tarifa de $25 para usar el proceso de disputa. Si la agencia que revisa su disputa está de acuerdo con usted, deberá pagar el precio de esta estimación de buena fe. Si la agencia no está de acuerdo con usted y está de acuerdo con el proveedor o centro de atención médica, tendrá que pagar la cantidad más alta.</p><p>Para obtener más información y obtener un formulario para iniciar el proceso, visite www.cms.gov/nosurprises o llame al 1-877-696-6775.</p><p>Para preguntas o más información sobre su derecho a un Estimado de buena fe o el proceso de disputa, visite www.cms.gov/nosurprises o llame al 1-877-696-6775.</p><p>Guarde una copia de este Estimado de buena fe en un lugar seguro o tome fotografías de él. Es posible que lo necesite si se le factura una cantidad mayor.</p>",
      "estimateRequestedAmountNotice": "{{ amount }} Debido Por {{ DOS }}",
      "estimateAmountPaid": "Pagaste {{ amount }}",
      "cardHolderName": "Nombre del titular de la tarjeta: {{name}}",
      "billSummaryHeader": "Cómo se calculó su costo",
      "billSummaryServiceAmount": "Costo Total:",
      "billSummaryInsuranceCoverage": "Cobertura de Seguro: ",
      "billSummaryOtherAdjustments": "Pagos y Ajustes",
      "billSummaryPatientPaid": "Pagos del paciente:",
      "billSummaryCost": "Su Costo:",
      "primaryInsurance": "Segury Priario:",
      "primaryInsuranceNoColon": "Segury Priario",
      "totalAmountDue": "Monto Total Adeudado",
      "billReasons": "Su factura incluye:",
      "estimates": "Estimados",
      "bills": "Facturas",
      "upcoming": "Próximo",
      "youHavePaid": "Has Pagado",
      "dueBy": "Debido Por",
      "by": "por",
      "accountInfo": "Informacion de Cuenta",
      "seeAll": "Ver Todo",
      "services": "Servicios",
      "patientPayments": "Pagos del Paciente",
      "serviceCharges": "Cargos por Servicio",
      "insuranceContribution": "Contribución al Seguro",
      "insuranceCoverage": "Cobertura del Seguro",
      "insurancePayments": "Pagos de Seguros",
      "insurancePaymentsPending": "Pagos de Seguros Pendientes",
      "insuranceAdjustments": "Ajustes de Seguro",
      "providerAdjustments": "Ajustes del Proveedor",
      "otherAdjustments": "Otros Ajustes",
      "totalCharges": "Cargos Totales",
      "noEstimate": "Aún no hay estimaciones",
      "noEstimateDetails": "Las estimaciones de los próximos servicios aparecerán aquí.",
      "noBillDetails": "Las nuevas facturas aparecerán aquí a medida que se procesen.",
      "noBill": "Sin facturas todavía",
      "noActivity": "Sin actividad todavía",
      "noActivityDetails": "La actividad de la cuenta aparecerá aquí.",
      "inNetworkProvider": "Proveedor dentro de la red",
      "servicesFor": "Servicios Para:",
      "accountNumberShort": "Cuenta #",
      "enterSecureHealthCode": "Ingrese el SecureHealthCode",
      "enterBillAmount": "Ingrese el monto de la factura",
      "findABill": "Encuentra una factura",
      "findABillDescription": "Ingrese los detalles de su estado de cuenta impreso más reciente.",
      "accountBalance": "Saldo de la cuenta",
      "accountDetails": "Detalle de Cuenta",
      "balanceTransferred": "Saldo Transferido",
      "saveEcheck": "Guarde eCheck para uso futuro",
      "saveCard": "Guarde la tarjeta para uso futuro",
      "expDate": "Caduca el {{ date }}",
      "expires": "Esta tarjeta vence el {{ date }}. Elija una fecha de pago anterior.",
      "expired": "Esta tarjeta caducó {{ date }}",
      "estimatedRemaining": "Restante Estimado",
      "estimatedRemainingCost": "Costo Restante Estimado",
      "originalEstimatedCost": "Costo Estimado Original",
      "estimateVoid": "Esta estimación ya no es válida y no se pueden realizar los pagos.",
      "infoAndDisclaimers": "Información importante y descargos de responsabilidad"
    },
    "linkedAccounts": {
      "activeAccounts": "Cuentas Activas",
      "providerName": "Proveedor",
      "accountNum": "Número de Cuenta",
      "billingName": "Nombre del Paciente",
      "disassociate": "Eliminar",
      "noAssociatedAcc": "No hay cuentas activas.",
      "confirmDisassociation": "¿Estás seguro de que quieres <br />eliminar esta cuenta?",
      "accountInfoLabel": "¡Advertencia! Una vez que confirme, se eliminarán todos los datos asociados con esta cuenta.<br /><br /> <b>{{guarantorName}}</b><br />Cuenta:&nbsp;{{accountNumber}}",
      "accountRemoved": "Cuenta #&nbsp;{{accountNumber}}",
      "argMethodDisassociated": "<b>{{guarantorName}}</b><br />ha sido removido.",
      "disassociateError": "Huy! Algo salió mal. Inténtalo de nuevo."
    },
    "paymentForm": {
      "method": {
        "stepName": "Método"
      },
      "billing": {
        "stepName": "Dirección"
      },
      "confirm": {
        "stepName": "Confirmación"
      }
    },
    "payment": {
      "amount": {
        "question": "¿Cuánto desea pagar?",
        "selectDifferent": "Por favor, seleccione una opción de pago diferente:",
        "stepName": "Monto de pago",
        "agreementStepName": "Monto del acuerdo de pago",
        "agreementAmountSummary": "{{agreementAmount}} pendiente",
        "payBillBalArg": "Monto de factura de pago: <b> {{calculatedTotal}} </b>",
        "payBillBalArgDiscount": "Monto de factura de pago con {{discountPolicy}}&nbsp;Descuento: <br /> <b> {{calculatedTotal}} </b>",
        "payAccountBalArg": "Pagar saldo de la cuenta: <b> {{calculatedTotal}} </b>",
        "payAccountBalArgDiscount": "Pagar saldo de la cuenta con {{discountPolicy}}&nbsp;Descuento: <br /> <b> {{calculatedTotal}} </b>",
        "payAnother": "Pagar otra cantidad",
        "otherPaymentOptions": "Revisar otras opciones de pago",
        "payOnce": "¿Desea realizar un pago único?",
        "payOverTime": "¿Desea pagar en el tiempo?",
        "updateExistingPlan": "¿Desea actualizar su plan de pago existente<br/> para incluir los nuevos cargos?",
        "planInstallmentOption": "{{installmentAmount}} / mes, {{installmentCount}} meses",
        "messageProvider": "Mensaje a proveedor",
        "noneOfTheseOptionsWorkForMe": "Ninguna De Estas Opciones Me Funciona.",
        "reviewFinancingOptions": "Opciones de Financiamiento",
        "lowMonthlyPaymentOptions": "Opciones de Pago Mensuales Bajas",
        "paymentsAsLowAs": "Pagos Tan Bajos Como {{monthlyPayment | currency}}/Mes*",
        "paymentsAsLowAsDisclaimer": "* El pago mensual mínimo de {{monthlyPayment | currency}} se estima en base a {{amount | currency}} financiados al {{apr}}% TAE durante {{duration}} meses. La tasa de porcentaje anual real varía entre 0% y 29.99% y los plazos de pago varían entre 24 y 48 meses, dependiendo de su solvencia. Los pagos variarán según el monto del préstamo y la oferta recibida.",
        "getFinancingOptionsErrorMessage": "Ocurrió un error al intentar cargar sus opciones de financiamiento. Vuelva a intentarlo.",
        "noFinancialOptionsFound": "Lo sentimos, no encontramos ninguna opción de financiamiento para ofrecerte.",
        "planDisabledBecauseOfBadDebt": "Fecha de pago",
        "singlePaymentPlanDisclaimer": "Tiene un plan de pago existente con {{providerName}}. Para agregar nuevos saldos a su plan, <a ng-click=\"VueEventTransmitter.$emit('message:compose', { secureCode: bill.secureCode });\">envíenos un mensaje</a> o comuníquese con Servicio al Cliente al {{providerPhoneNumber}}.",
        "singlePaymentPlanDisclaimerNoMessaging": "Tiene un plan de pago existente con {{providerName}}. Para agregar nuevos saldos a su plan, comuníquese con Servicio al Cliente al {{providerPhoneNumber}}.",
        "existingPaymentPlanOnAccountDisclaimar": "Tiene un plan de pago existente en esta cuenta",
        "wouldLikeAssistanceSettingUpPaymentPlan": "Quisiera ayuda para establecer un plan de pago",
        "payEstimateBal": "Pagar monto estimado: {{calculatedTotal}}",
        "payEstimateRequestedAmount": "Pagar {{percentage}}% de la cantidad Estimada: {{calculatedTotal}}",
        "payEstimateBalAgreement": "Regístrese para un acuerdo de pago por el monto restante: {{calculatedTotal}}",
        "estimateRemainder": "¿Cómo le gustaría pagar el resto?",
        "cannotPayToday": "No puedo pagar <b>hoy</b>"
      },
      "date": {
        "question": "¿Cuándo le gustaría pagar?",
        "stepName": "Fecha de pago",
        "firstPaymentDate": "Primera fecha de pago",
        "todayArg": "Fecha: <b> {{todayDate}} </b>",
        "laterDate": "Pagar en ena fecha posterior",
        "dateFromExistingPlan": "Próxima fecha en el plan: <b> {{nextDate}} </b>",
        "agreementDateSummary": "A partir del {{date}}"
      },
      "method": {
        "question": "¿Cómo desea pagar?",
        "stepName": "Método de pago",
        "cardMethod": "Tarjeta de crédito / débito",
        "eCheckMethod": "Cheque electrónico",
        "hsaMethod": "HSA/FSA tarjeta",
        "userAnotherCard": "Usar otra tarjeta",
        "userAnotherECheck": "Usar otro cheque electrónico",
        "userAnotherCardOrECheck": "Usar otra tarjeta o cheque electrónico"
      },
      "billing": {
        "question": "¿Cuál es su dirección de facturación para <br /> {{methodSummary}}?",
        "stepName": "Dirección de facturación",
        "useAnotherAddress": "Usar otra dirección de facturación",
        "billingAddressSection": "Ingrese la dirección de facturación."
      },
      "confirm": {
        "planAmount": "{{installmentAmount}} / mes por {{installmentCount}} meses",
        "question": "¿Se ve todo bien?",
        "stepName": "Confirmación",
        "cardBilling": "Dirección de facturación de la tarjeta",
        "eCheckBilling": "Dirección de facturación eCheck",
        "eCheckAuthorizationSingle": "Autorizo a Patientco en nombre de {{providerName}} para iniciar un débito electrónico único desde mi cuenta por la cantidad de {{amountSummary}} en {{date}} de la cuenta bancaria registrada. Entiendo que esta autorización permanecerá vigente hasta que notifique a {{providerName}} que deseo revocarla.",
        "eCheckAuthorizationPaymentPlan": "Autorizo a Patientco en nombre de {{providerName}} para iniciar débitos electrónicos recurrentes de mi cuenta por la cantidad de {{amountSummary}} a partir de {{date}} de la cuenta bancaria registrada. Entiendo que esta autorización permanecerá vigente hasta que notifique a {{providerName}} que deseo revocarla.",
        "paymentAgreementStepName": "Acuerdo de pago",
        "paymentAgreement": "Autorizo a {{providerName}} a aplicar un cargo por el monto del Acuerdo de pago indicado anteriormente a partir del {{date}}. Entiendo que recibiré un aviso 3 días antes de que se cobre el pago y que puedo cancelar antes de que se procese el pago. Este permiso es para una sola transacción y no proporciona autorización para ningún débito o crédito adicional no relacionado."
      },
      "friendlyType": {
        "standard": "Pago",
        "badDebt": "Pago de deuda incobrable",
        "balance": "Pago de saldo",
        "copay": "Copago",
        "insurance": "Pago de seguro",
        "prepayment": "Pago adelantado",
        "other": "Otro",
        "agreement": "Importe autorizado a cobrar"
      },
      "financing": {
        "application": {
          "stepName": "Solicitud de financiamiento",
          "financingApplyHeader": "Para ver si hay ofertas disponibles, complete este formulario:",
          "electronicDisclosureConsentText": "Al marcar la casilla, usted certifica que ha leído, retenido y acepta el <a href='{{electronicDisclosureConsentLink}} target''_blank'> Consentimiento para revelaciones electrónicas </a> y entiendo que esto constituye su firma electrónica nos autoriza a procesar este formulario en su nombre",
          "electronicDisclosureConsentError": "Es necesario aceptar el consentimiento de las Divulgaciones electrónicas",
          "creditScoreNotice": "Ver ofertas no afecta su puntaje de crédito",
          "financingViewOffers": "Ver mis ofertas",
          "monthlyIncomeHeader": "Total bruto mensual Ingresos familiares",
          "monthlyIncomeBody": "No se deben incluir los ingresos de pensión alimenticia, manutención infantil o mantenimiento por separado si no desea que se considere como base para el pago de esta obligación. <br> <br> Residentes casados ​​de Wisconsin: combine su información y la de su cónyuge en esta solicitud.",
          "incomeGreaterThanZeroError": "El ingreso debe ser mayor que cero.",
          "disclaimersHeader": "Lea las exenciones de responsabilidad a continuación y desplácese hacia abajo para ver sus ofertas",
          "newAccountProceduresHeader": "Información importante sobre los procedimientos para abrir una nueva cuenta",
          "newAccountProceduresBody": "Para ayudar al gobierno a combatir la financiación de las actividades de terrorismo y lavado de dinero, la ley federal exige que todas las instituciones financieras obtengan, verifiquen y registren información que identifique a cada persona que abre una cuenta. Qué significa esto para usted: cuando solicite un préstamo, le pediremos su nombre, domicilio, dirección de correo electrónico, fecha de nacimiento y otra información que nos permitirá identificarlo. También podemos pedir ver su licencia de conducir u otros documentos de identificación",
          "stateLawNoticesHeader": "Avisos de la Ley del Estado",
          "stateLawNoticesBody": "<p><b>Residentes de California:</b> Si está casado, puede solicitar una cuenta separada.</p>\n<p><b>Residentes de Delaware:</b> Los cargos por servicio que no excedan de los permitidos por la ley se cargarán en los saldos pendientes de mes a mes.</p>\n<p><b>Residentes de Maryland:</b> Los cargos por financiamiento se impondrán en montos o tasas que no excedan de los permitidos por la ley.</p>\n<p><b>Residentes de Nueva York:</b> Los residentes de Nueva York pueden comunicarse con el Departamento de Estado de Nueva York de Servicios financieros por teléfono o visite su sitio web para obtener información gratuita sobre las tarifas de las tarjetas de crédito, las tarifas y los períodos de gracia. Puede llamar al Departamento de Servicios Financieros del Estado de Nueva York al 800-342-3736 o visitar su sitio web: www.dfs.ny.gov.</p>\n<p><b>Residentes de Ohio:</b> Las leyes de Ohio contra la discriminación se requiere que todos los acreedores hagan que el crédito esté igualmente disponible para todos los clientes solventes, y que las agencias de informes crediticios mantengan historiales de crédito separados para cada individuo que lo solicite. La comisión de derechos civiles de Ohio administra el cumplimiento de esta ley.</p>\n<p><b>Residentes de Vermont:</b> El prestamista se dedica a la producción de préstamos.</p>\n<p><b>Residentes casados ​​de Wisconsin:</b> Ninguna disposición de un acuerdo de propiedad matrimonial, una declaración unilateral bajo la sección 766.59 o un decreto judicial bajo la sección 766.70 afecta adversamente el interés del acreedor a menos que el acreedor, antes del momento en que se otorgue el crédito, se le proporcione una copia del acuerdo, declaración o decreto o tiene conocimiento real de la disposición adversa cuando se incurre en la obligación con el acreedor. Estamos obligados a pedirle que proporcione el nombre y la dirección de su cónyuge.</p>",
          "electronicCommunicationConsentTitle": "Consentimiento especial a la comunicación electrónica",
          "electronicCommunicationConsentBody": "Al hacer clic en \"Ver mis ofertas\" y al enviar una solicitud para su procesamiento electrónico, usted autoriza expresamente El Prestamista se comunicará con usted sobre su solicitud y cualquier crédito extendido, o para cualquier otro propósito legal, incluyendo, sin limitación, servicio al cliente o cobro, en cualquier dirección o número de teléfono que pueda, de vez en cuando, proporcionar (incluyendo cualquier número de teléfono o línea telefónica fija portada), e incluye expresamente, sin limitación, las llamadas realizadas mediante marcación y anuncio automáticos de dispositivos que pueden reproducir mensajes grabados.",
          "submitApplicationConsentTitle": "Consentimiento para enviar la solicitud",
          "submitApplicationConsentBody": "Al hacer clic en \"Ver mis ofertas\" a continuación y enviar una solicitud electrónicamente para su procesamiento, por la presente certifica que tiene al menos 18 años de edad (19 en AL o NE) y que todo lo que mencionó anteriormente es verdadero y preciso. Usted certifica que actualmente no tiene una petición presentada en virtud de las leyes federales de bancarrota (ya sea voluntaria o involuntaria) y no prevé presentar una petición. Si se aprueba para crédito, usted acepta estar sujeto a los términos del Acuerdo de Crédito que se le proporcionó. Usted autoriza El Banco de Missouri, sus sucesores, cesionarios y agentes (el \"Prestamista\") para investigar su solvencia y obtener un informe de crédito sobre usted para cualquier propósito legal, incluida cualquier actualización, extensión de crédito, revisión o cobro de su cuenta. y usted autoriza la divulgación de dicha información al Prestamista. Si lo solicita, el Prestador le dirá si se solicitó algún informe de crédito y, de ser así, el nombre y la dirección de la agencia de informes del consumidor que proporcionó el informe."
        },
        "offers": {
          "stepName": "Ofertas disponibles",
          "financingOptionsHeaderMultiple": "¡Felicitaciones, las ofertas están disponibles!",
          "financingOptionsHeaderSingle": "¡Felicidades! ¡Aquí está su oferta!",
          "financingOptionHeaderCreditLimit": " con un {{currencyCreditLimit}} límite de crédito.",
          "financingOptionCreditLimit": "Límite de crédito: {{currencyCreditLimit}}",
          "financingOptionHeaderDeferredInterest": "Si paga por completo dentro {{deferredInterestMonths}} meses",
          "financingOptionDeferredInterest": "Deferred Interés: {{deferredInterestMonths}} meses",
          "financingOptionNoInterest": "No hay interés",
          "financingOptionLowMonthly": "Pago mensual bajo",
          "financingOptionAmountAndMonths": "{{currencyMonthlyAmount}} / mes por {{months}} meses",
          "financingOptionAPR": "Tasa porcentual anual: {{rate}}%",
          "financingOptionInterestBearing": "{{currencyMonthlyAmount}} / mes, {{months}} meses, {{rate}}% tasa de interés",
          "financingOptionInterestFree": "{{currencyMonthlyAmount}} / mes, {{months}} meses",
          "chooseFinancingOptionErrorMessage": "Se produjo un error al comunicarse con nuestro socio financiero. Inténtelo de nuevo.",
          "monthlyPaymentDisclaimer": "Pago mensual: los pagos mínimos mensuales estimados incluyen cargos financieros a un APR del valor que se muestra en la oferta correspondiente y un pago total estimado, el pago mensual mínimo multiplicado por el plazo de reembolso. Asumiendo el monto de la compra de {{chargeAmount | currency}} y que todos los pagos se realicen en forma oportuna, la transacción de compra se pagará dentro del número de meses enumerados para el plazo de reembolso en la casilla de oferta correspondiente.",
          "deferredInterestDisclaimer": "Interés diferido: los intereses se cargarán a su cuenta desde la fecha de compra si el saldo de la compra no se paga en su totalidad dentro del período promocional o si realiza un pago atrasado. Debe pagar más que su pago mínimo requerido para evitar intereses. Consulte el Acuerdo del titular de la tarjeta para obtener más detalles."
        },
        "existingAccount": {
          "stepName": "Confirmación",
          "existingAccountHeader": "Según la información proporcionada, hemos encontrado una cuenta {{existingAccount.vendorName}} existente.",
          "accountNumberLabel": "Número de cuenta:",
          "availableCreditLabel": "Crédito disponible:",
          "authorizeTransactionSubheader": "Autorizar la transacción para {{chargeAmount | currency}}",
          "authorizeTransactionDisclaimer": "Al marcar la casilla, usted acepta permitir que {{existingAccount.vendorName}} inicie una transacción por el monto de la factura correspondiente. Si su línea de crédito es mayor que el monto de su factura, podrá usarla para facturas futuras con {{providerName}} si lo desea.",
          "submitExistingAccountConfirmationErrorMessage": "Se produjo un error al comunicarse con nuestro socio financiero. Vuelva a intentarlo.",
          "partialPaymentDisclaimer": "Tenga en cuenta que tendrá un saldo restante de {{existingAccount.amountDueNotCovered | currency}}."
        },
        "summary": {
          "stepName": "Resumen de términos de crédito",
          "financingSummaryHeader": "Revisar y aceptar su oferta:",
          "acceptOfferDisclaimer": "Una vez que haga clic en Aceptar oferta, se creará su cuenta {{vendorName}} y no podrá seleccionar una oferta diferente .",
          "acceptOfferButton": "Aceptar oferta",
          "reviewTerms": "Antes de seleccionar su oferta, consulte el <a id='summary-terms' href='{{termsUrl}}' target='_blank'> Resumen de términos de crédito </a> que resume los términos clave del titular de la tarjeta Acuerdo que regirá su cuenta rotatoria {{vendor}}."
        },
        "confirm": {
          "stepName": "Confirmación",
          "financingConfirmHeader": "¡Ya casi terminé!",
          "cardholderAgreementSubheader": "Acuerdo de Leer y guardar su titular de la tarjeta:",
          "cardholderAgreementDisclaimer": "Al marcar la casilla, acepta que (i) ha leído y entienda su <a id='cardholder-agreement' href='{{cardholderAgreementUrl}}' target='_blank'> Acuerdo del Titular de la Tarjeta </a> incluyendo los términos de cualquier oferta de interés diferido y acepte estar sujeto a sus términos, y (ii) han proporcionado el corrija la dirección de correo electrónico para conservar una copia del Acuerdo del titular de la tarjeta para sus registros.",
          "authorizeTransactionSubheader": "Autorizar la transacción para {{chargeAmount | currency}}",
          "authorizeTransactionDisclaimer": "Al marcar la casilla, usted acepta permitir que {{vendorChosen}} inicie una transacción para {{chargeAmount | currency}}. Si su línea de crédito es mayor que esta cantidad, podrá usarla para futuras facturas con {{providerName}} si lo desea.",
          "partialPaymentDisclaimer": "Tenga en cuenta que tendrá un saldo restante de {{selectedOption.amountDueNotCovered | currency}}."
        },
        "success": {
          "financingRedirectHeader": "Le redirigiremos en breve...",
          "financeRedirectSubContent": "<br> Si no se le redirige automáticamente<br>por favor <a id = 'redirectUrl' href = '{{redirectUrl}}' target = '_blank'> haga clic aquí </a> para continuar.",
          "financingSuccessHeader": "Gracias por financiar a través de {{vendor}}!",
          "financeSuccessSubContent": "{{vendor}} se comunicará con usted directamente con los detalles de la cuenta. Si tiene alguna pregunta, póngase en contacto con {{vendor}} directamente por teléfono en <b> {{vendorPhone}} </b> o por correo electrónico en <b> {{vendorEmail}} </b>."
        },
        "paymentForm": {
          "infoHeader": "Tarjeta de {{proveedor}}",
          "infoContent": "<p> Según su cuenta existente con {{vendor}}, puede usar su línea de crédito abierta para financiar sus facturas con <b> {{provider}} </b> . </p> <p> Crédito disponible: {{formattedAvailableCredit}} </p> <p> Si tiene preguntas sobre su cuenta {{vendor}}, llame a {{vendorPhone}} o envíe un correo electrónico a {{vendorEmail}}. </p>"
        },
        "status": {
          "approved": {
            "title": "Gracias por inscribirse con {{vendor}}!",
            "subtitle": "Revise su bandeja de entrada en los próximos días para obtener información adicional de la cuenta de {{vendor}}."
          },
          "pending": {
            "title": "Información de inscripción bajo revisión",
            "subtitle": "Su información ha sido enviada a un especialista de {{provider}} para su verificación."
          },
          "rejected": {
            "title": "Póngase en contacto con su proveedor de atención médica",
            "subtitle": "La configuración de su cuenta requiere asistencia de {{provider}}. Comuníquese con {{provider}} al {{phoneNumber}} para obtener más ayuda."
          }
        },
        "errors": {
          "firstName": "Comprueba tu nombre e inténtalo de nuevo.",
          "lastName": "Comprueba tu apellido e inténtalo de nuevo.",
          "email": "Comprueba tu dirección de correo electrónico e inténtalo de nuevo.",
          "primaryPhone": "Verifique su número de teléfono principal y vuelva a intentarlo.",
          "dob": "Verifique su fecha de nacimiento y vuelva a intentarlo.",
          "ssn": "Verifique su número de seguro social y vuelva a intentarlo.",
          "monthlyIncome": "Verifique los ingresos mensuales de su hogar y vuelva a intentarlo.",
          "addressLine1": "Comprueba tu dirección e inténtalo de nuevo.",
          "addressLine2": "Verifique la línea 2 de su dirección y vuelva a intentarlo.",
          "poBox": "No permitimos apartados postales en este momento. Ingrese una dirección diferente y vuelva a intentarlo.",
          "city": "Comprueba tu ciudad e inténtalo de nuevo.",
          "stateZip": "Asegúrese de que su código postal y su estado sean correctos y vuelva a intentarlo.",
          "tryAgain": "@:payment.amount.getFinancingOptionsErrorMessage",
          "alreadyHasAnAccount": "Parece que ya hay una cuenta asociada con este número de seguro social. Asegúrese de utilizar la misma dirección de correo electrónico y fecha de nacimiento y vuelva a intentarlo."
        }
      }
    },
    "newPaymentFormFlow": {
      "genericError": "Hubo un error al guardar su método de pago.",
      "saveMethod": "Guardar método",
      "title": "Nuevo método de pago"
    },
    "paymentFlow": {
      "amount": {
        "accessOneTitle": "Explore las opciones de financiamiento a través de AccessOne",
        "accountBalanceTitle": "Saldo de la cuenta de pago: {{amount}}",
        "accountBalanceDiscountTitle": "Pague el saldo de la cuenta y obtenga un {{percent}} de descuento:",
        "clearBalanceSuccessText": "Revise su bandeja de entrada en los próximos días para obtener información adicional sobre la cuenta de ClearBalance.",
        "clearBalanceSuccessTitle": "Gracias por inscribirse en ClearBalance",
        "clearBalanceTitle": "Explore las opciones de financiamiento a través de ClearBalance",
        "curaeTitle": "Explora opciones de financiación a través de Curae",
        "desktopPrompt": "Elige cuánto te gustaría pagar.",
        "estimateRequestedAmountTitle": "Pagar {{percent}}% prepago: {{amount}}",
        "estimateRequestedAmountSubtitle": "Pague una parte hoy, pague el resto más tarde",
        "estimateRequestedRemainingAmountTitle": "Pagar el prepago restante: {{amount}}",
        "estimateTotalAmountRemainingTitle": "Pagar el costo restante estimado: {{amount}}",
        "estimateTotalAmountTitle": "Pagar el costo total estimado: {{amount}}",
        "mobilePrompt": "Escoge una opción.",
        "partialPaymentTitle": "Hacer un pago parcial",
        "partialPaymentSubtitle": "Personaliza tu cantidad",
        "oneTimePayment": "Pago único",
        "errors": {
          "amountNotPositive": "El monto debe ser mayor a $0.00.",
          "amountTooHigh": "El monto debe ser menor o igual a su saldo.",
          "amountTooLow": "El monto debe ser mayor o igual a {{minAmount}}."
        },
        "financingSubtitle": "Obtenga una preaprobación gratis sin impacto en su puntaje de crédito",
        "paymentPlan": {
          "title": "Crear un plan de pago",
          "updateTitle": "Actualizar plan de pago",
          "subtitle": "Sin intereses, automático",
          "installmentOptionHeader": "{{ formattedAmount }} / mes",
          "installmentOptionSubheader": "durante {{ numberOfMonths }} meses"
        },
        "statementBalanceTitle": "Saldo del extracto de pago: {{amount}}",
        "statementBalanceDiscountTitle": "Pague el saldo del extracto y obtenga {{percent}} de descuento:",
        "subAccountBalanceTitle": "Monto Total: {{amount}}",
        "updatePlan": {
          "amountPerMonth": "{{ formattedAmount }}/mes",
          "numberOfPaymentsMade": "{{ amountCompleted }} de {{ totalAmount }} pagos realizados",
          "prompt": "Elija nuevos términos para su plan.",
          "title": "Actualizar plan de pago",
          "subtitle": "Incluya nuevos cargos en su plan existente",
          "yourCurrentPlan": "Su plan actual:"
        }
      },
      "date": {
        "prompt": "Elige cuándo quieres pagar.",
        "paymentPlanPrompt": "Elija cuándo desea que comience su plan de pago.",
        "updatePlanHeader": "Mensual, el día {{ formattedDate }}",
        "updatePlanPrompt": "Elige tu próxima fecha de pago.",
        "updatePlanSubheader": "Próximo pago programado para el {{ formattedDate }}",
        "updatePlanYourCurrentPlan": "Su plan actual"
      },
      "financing": {
        "accessOne": {
          "congratulations": "¡Felicidades! Aquí está su oferta:",
          "continue": "Continuar con AccessOne",
          "disclaimer": "Las ofertas anteriores son opciones proporcionadas por nuestro socio financiero de confianza, AccessOne. Será redirigido para completar el proceso de solicitud.",
          "amountPerMonth": "{{ formattedAmount }}/mes",
          "amountPerMonthWithInterest": "{{ formattedAmount }}/mes + {{interestRate}}% de interés",
          "length": "Durante {{ numberOfMonths }} meses",
          "error": "Ocurrió un error al comunicarse con AccessOne. Inténtalo de nuevo."
        },
        "curae": {
          "viewOffers": "Ver mis ofertas",
          "completeFormTitle": "Complete este formulario para ver las ofertas disponibles.",
          "completeFormSubtitle": "Ver ofertas no afectará su puntaje de crédito.",
          "personalInformation": "Informacion personal",
          "bankAccount": "Todas las cuentas de Curae son emitidas por The Bank of Missouri, St. Robert, MO.",
          "mulitpleOffersTitle": "¡Felicidades! Tenemos ofertas disponibles con un límite de crédito de ${{ creditLimit }}.",
          "oneOfferTitle": "¡Felicidades! Tenemos ofertas disponibles con un límite de crédito de ${{ creditLimit }}.",
          "amountNoApr": "${{ amount }}/mes 0% APR",
          "amountApr": "${{ amount }}/mes + {{ apr }}% APR",
          "amountAprDeffered": "${{ amount }}/mes + {{ apr }}% APR*",
          "months": "Durante {{ months }} meses",
          "deferredInterest": "* Sin intereses si se paga en su totalidad dentro de los {{ months }} meses",
          "reviewOffer": "Revise y acepte su oferta.*",
          "creditLimit": "Límite de crédito: ${{ creditLimit }}",
          "onceAccepted": "* Una vez aceptado, se creará tu Curae accept y no podrás seleccionar una oferta diferente.",
          "cardholderAgreement": "Acuerdo del titular de la tarjeta",
          "authorizeTransactionTitle": "Autorizar transacción para ${{ money }}",
          "authorizeTransactionBody": "Al marcar esta casilla, acepta permitir que Curae procese una transacción por <strong>${{ amount }}</strong>. Si su línea de crédito es mayor que esta cantidad, podrá usarla para futuras facturas con {{ provider }}.",
          "acceptAndProcess": "Aceptar y procesar",
          "cardholderAgreementError": "Es necesario aceptar el Acuerdo del titular de la tarjeta.",
          "authorizeTransactionError": "Se requiere aceptar autorizar la transacción.",
          "electronicDisclosureConsentText": "Al marcar la casilla, certifica que ha leído y retenido la información anterior, y que está de acuerdo con los <a id='electronic-disclosures' href='{{electronicDisclosureConsentLink}} target''_blank'>Consentimiento para revelaciones electrónicas</a>. Marcar esta casilla también constituye su firma electrónica, lo que nos autoriza a procesar este formulario en su nombre.",
          "newMonthlyIncomeBody": "No se deben incluir los ingresos de pensión alimenticia, manutención infantil o mantenimiento por separado si no desea que se considere como base para el pago de esta obligación.",
          "wisconsinResidents": "Residentes casados ​​de Wisconsin",
          "wisconsinResidentsBody": "Combine su información y la de su cónyuge en esta solicitud.",
          "newAccountProceduresHeader": "Procedimientos para abrir una cuenta"
        },
        "noOffers": {
          "title": "No hay ofertas disponibles",
          "body": "Desafortunadamente, no encontramos ninguna opción de financiamiento para ofrecerle en este momento. Elija una opción de pago diferente o comuníquese con su proveedor para obtener más ayuda."
        },
        "redirect": {
          "title": "Te redirigiremos en breve",
          "body": "Si no es redirigido automáticamente, haga clic en el botón de abajo para continuar.",
          "action": "Redrigir"
        }
      },
      "method": {
        "prompt": "Elige cómo te gustaría pagar.",
        "newCard": "Nuevo crédito/débito"
      },
      "confirmation": {
        "estimateDisclaimer": "Este plan de pago es solo para esta estimación. Después de que se preste su servicio de atención médica y se emita un estado de cuenta, este plan de pago se cancelará. Cualquier saldo restante se reflejará en su estado de cuenta.",
        "paymentPlanMonthlyDate": "Mensual, el día {{ formattedDate }}",
        "paymentPlanFirstPaymentDate": "Primer Pago: {{ formattedDate }}"
      },
      "confirmCancel": {
        "cancelPayment": "¿Cancelar el pago?",
        "paymentNotProcessed": "Su pago no será procesado.",
        "noContinuePaying": "NO, SEGUIR PAGANDO",
        "yesCancelPayment": "SÍ, CANCELAR PAGO"
      },
      "actions": {
        "back": "Volver",
        "cancel": "Cancelar",
        "continue": "Continuar",
        "processing": "Procesando...",
        "processPayment": "Procesar pago",
        "processPaymentFuture": "Programar pago"
      },
      "backButtons": {
        "accountDetails": "Cuenta...{{accountNumber}}",
        "billSummary": "Resumen de la factura",
        "estimateSummary": "Resumen de estimación",
        "amount": "Opcion de pago",
        "date": "Fecha de pago",
        "method": "Método de pago"
      },
      "steps": {
        "amount": "Opcion de pago",
        "availableOffers": "Ofertas disponibles",
        "curaeApplication": "Aplicación Curae",
        "date": "Fecha de pago",
        "acceptOffer": "Aceptar la oferta",
        "method": "Método de pago",
        "confirmation": "Confirmación"
      },
      "errors": {
        "generic": "Hubo un error al procesar su pago. Vuelva a intentarlo más tarde o comuníquese con su proveedor al {{phoneNumber}} para completar su pago.",
        "methodUnavailableAll": "Actualmente estamos experimentando dificultades para procesar los pagos. Pedimos disculpas por las molestias. Por favor, inténtelo de nuevo más tarde",
        "methodUnavailableCard": "Actualmente estamos experimentando dificultades para procesar los pagos con tarjeta. Vuelva a intentarlo con otro método de pago o comuníquese con su proveedor al {{phoneNumber}} para completar su pago.",
        "methodUnavailableECheck": "Actualmente estamos experimentando dificultades para procesar pagos con cheques electrónicos. Vuelva a intentarlo con otro método de pago o comuníquese con su proveedor al {{phoneNumber}} para completar su pago.",
        "paymentCardExpired": "Esta tarjeta ha caducado. Intente utilizar otro método de pago.",
        "paymentDeclined": "Esta tarjeta fue rechazada. Intente utilizar otro método de pago.",
        "paymentDuplicate": "Parece que está intentando enviar un pago duplicado. Si esto fue intencional, comuníquese con su proveedor al {{phoneNumber}} para completar su pago.",
        "paymentInvalidCard": "Esto no parece ser una tarjeta válida. Intente verificar el número de tarjeta y la fecha de vencimiento, o use un método de pago diferente.",
        "prematureExpiration": "Esta tarjeta caducará antes de la fecha de pago. Elija una fecha diferente o use un método de pago diferente.",
        "invalidParameters": "Parece que hay un parámetro no válido. Corrija cualquier problema y vuelva a intentarlo.",
        "paymentProcessingError": "Hubo un problema al procesar su pago. Inténtalo de nuevo.",
        "accountPaidInFull": "La cuenta ya está pagada en su totalidad.",
        "networkError": "Hubo un error de red al intentar procesar su pago. Inténtalo de nuevo."
      }
    },
    "dialogs": {
      "confirmPasswordHeader": "Confirmar contraseña",
      "confirmPasswordSubheader": "Para seguridad razones, ingrese su contraseña.",
      "deactivateAccountHeader": "Desactivar cuenta",
      "deactivateAccountSubheader": "Por razones de seguridad, ingrese su contraseña para continuar.",
      "deactivateAccountWarning": "¡Advertencia! Una vez que desactiva su cuenta, perderá el acceso a su PatientWallet<sup>&reg;</sup> y a todos los datos asociados con ella.",
      "deactivateAccountSuccessHeader": "Su cuenta ha sido desactivada.",
      "deactivateAccountSuccessSubheader": "Si ha desactivado su cuenta por error, por favor contáctenos al 1-844-422-4779 o support@patientco.com.",
      "thanksForPayment": "¡Gracias por su pago!",
      "emailSentTo": "Hemos enviado un recibo por correo electrónico a <br /> {{email}}",
      "copySentTo": "Cuando su proveedor responda, le enviaremos un correo electrónico a <br /> {{email}}",
      "successfulLogout": "Has cerrado sesión correctamente.",
      "thanksAndComeBack": "Gracias por usar Patientco. <br /> ¡Esperamos volver a recibirlo!",
      "welcome": "¡Bienvenido a Patientco!",
      "happyYouAreHere": "Crea una cuenta para comenzar.",
      "thanksForComingBack": "Nos complace que hayas vuelto.",
      "leavingPaymentFlow": "¿Estás seguro de que quieres abandonar esta página? Su pago no se ha procesado.",
      "yourBalanceWasUpdated": "¡Su saldo se ha actualizado!",
      "dbuReasonHeaderUp": "¿Por qué mi saldo ha aumentado?",
      "dbuReasonHeaderDown": "¿Por qué ha disminuido mi saldo?",
      "dbuReason": "Desde su última factura, ha habido una nueva actividad en su cuenta. En la mayoría de los casos, el saldo actualizado refleja nuevos cargos, pagos o cambios en la contribución al seguro.",
      "dbuStillPayable": "No se preocupe, aún puede pagar <br /> el monto impreso en su factura.",
      "newerBillLoaded": "Los detalles que ingresó son de un antiguo proyecto de ley. Para su comodidad, hemos cargado la factura más reciente que refleja su información más reciente.",
      "demoDialog": "Entorno de demostración",
      "gatewayDown": "Actualmente tenemos dificultades para procesar los pagos. Pedimos disculpas por las molestias, por favor, inténtelo de nuevo más tarde.",
      "cardsHidden": "Actualmente tenemos dificultades para procesar los pagos con tarjeta de crédito. Realice su pago utilizando un cheque electrónico.",
      "eChecksHidden": "Actualmente estamos experimentando dificultades para procesar los pagos de cheque electrónico. Haga su pago con una tarjeta de crédito",
      "cardsExpired": "Al menos una de sus tarjetas de crédito ha caducado, o expirará antes de la fecha de su fecha de pago programada.",
      "contactTitle": "¡Gracias por contactar!",
      "contactSubtitle": "Nos complace escuchar de usted",
      "phiWarning": "Para su seguridad, por favor excluya la información de salud personal",
      "contactSent": "¡Gracias por su mensaje!",
      "contactThanks": "Nos pondremos en contacto con usted lo antes posible",
      "termsTitle": "Términos de uso",
      "welcomeBack": "Bienvenido atrás, {{name}}!",
      "termsUpdated": "Nuestros Términos de uso se han actualizado desde su último inicio de sesión.",
      "logoutWarningHeader": "Su sesión está a punto de caducar",
      "logoutWarningSubcontent": "Para su seguridad, esta sesión en línea finalizará en breve debido a la inactividad.",
      "activeChatWarningHeader": "Sesión de chat activa",
      "activeChatWarningSubcontent": "Actualmente tienes una sesión de chat activa que finalizará. ¿Estás seguro de que deseas cerrar la sesión?",
      "retryProcessPayment": "No pudimos procesar completamente su pago. Por favor, vuelva a intentar su presentación a continuación. No se preocupe, solo cargaremos su tarjeta una vez.",
      "feedbackTitleReceiptLink": "¿Cómo fue su experiencia de pago en línea?",
      "feedbackTitleClosedMessageLink": "¿Cómo fue su servicio al cliente de {{providerName}}?",
      "feedbackTitleNpsLink": "Dada su experiencia de facturación, ¿qué posibilidades hay de que recomiende {{providerName}} a un amigo o colega?",
      "feedbackSubtitlePaymentHappy": "¡Excelente! ¿Algún otro comentario?",
      "feedbackSubtitlePaymentSad": "Lamento escuchar eso! ¿Cómo podemos mejorar?",
      "feedbackSubtitleClosedMessageHappy": "¡Genial! ¿Algún otro comentario?",
      "feedbackSubtitleClosedMessageSad": "Lamento escuchar eso! ¿Qué podría mejorar su proveedor?",
      "feedbackSubtitleNpsHappy": "¡Excelente! ¿Algún otro comentario?",
      "feedbackSubtitleNpsSad": "Lamentamos escuchar eso. ¿Quieres decirnos por qué?<br>Tu recomendación nos ayudará a mejorar.",
      "feedbackCommentPlaceholder": "Comience a escribir comentarios...",
      "feedbackLabelNPS0": "Nada probable",
      "feedbackLabelNPS10": "Extremadamente probable",
      "feedbackOptionOther": "Otro",
      "thanksForFeedback": "¡Gracias por sus comentarios!",
      "accountIsFinanced": "Esta cuenta está siendo atendida actualmente por {{financedBy}}.",
      "contactFinancingVendor": "Para realizar un pago o para Para ayudar con su cuenta, comuníquese directamente con {{financedBy}}.",
      "updatePaymentFormConfirmHeader": "¿Cambiar método de pago?",
      "updatePaymentMethodButtonText": "Confirmar",
      "updatingPaymentMethodButtonText": "Actualizando...",
      "updateAndApplyPaymentMethodButtonText": "Confirmar",
      "updateAndApplyingPaymentMethodButtonText": "Procesando...",
      "confirmingButtonText": "Confirmando...",
      "addAnotherCard": "Agregar otra tarjeta",
      "addAnotherECheck": "Agregar otra comprobación electrónica",
      "addAnotherCardOrECheck": "Agregar otra tarjeta o verificación electrónica",
      "updatesToTermsText": "Hemos actualizado nuestros <a href=\"https://www.waystar.com/patientco-terms-of-use/\" target=\"_blank\"> Términos de uso </a> y <a href=\"https://www.waystar.com/patientco-privacy-policy/\" target=\"_blank\"> Política de privacidad </a> para que le resulte más fácil comprender qué información recopilamos y por qué. <br/> <br/> Como un recordatorio amistoso, Patientco nunca compartirá su información con comercializadores de terceros, y siempre puede actualizar sus Preferencias de comunicación dentro de su Configuración. Le recomendamos que revise nuestros nuevos <a href=\"https://www.waystar.com/patientco-terms-of-use/\" target=\"_blank\"> Términos de uso </a> y <a href=\"https: //www.waystar.com/patientco-privacy-policy/\" target=\"_blank\"> Política de privacidad </a>. <br/> <br/> Para aceptar los nuevos <a href=\"https://www.waystar.com/patientco-terms-of-use/\" target=\"_blank\"> Términos de uso </a> y <a href=\"https://www.waystar.com/patientco-privacy-policy/\" target=\"_blank\"> Política de privacidad </a>, haga clic en \"Aceptar\" a continuación.",
      "clearBalanceInfoFunded": "Si eligió participar en el programa ClearBalance, su saldo se reflejará como un saldo de $0. Envíe sus pagos a ClearBalance en <a href='https://www.myclearbalance.com' target='_blank'>https://www.myclearbalance.com</a>. Los fondos de ClearBalance se mostrarán en sus transacciones de PatientWallet como un desembolso del programa ClearBalance.",
      "clearBalanceInfoApplied": "Si ha elegido participar en el programa ClearBalance, su saldo se reflejará como un saldo de $0 una vez que realice su primer pago mínimo estándar. Envíe sus pagos a ClearBalance en <a href='https://www.myclearbalance.com' target='_blank'>https://www.myclearbalance.com</a>.",
      "removeCardTitle": "¿Quitar tarjeta?",
      "removeCardContent": "Esta tarjeta se eliminará de su PatientWallet.",
      "confirmChangePaymentMethod": "Este método de pago se utilizará para los pagos restantes de su plan.",
      "chooseDifferentMethod": "Elija un método diferente."
    },
    "links": {
      "whyPatientco": "Acerca",
      "news": "Noticias",
      "termsOfService": "Términos",
      "careers": "Carreras profesionales",
      "privacyPolicy": "Privacidad"
    },
    "misc": {
      "conjunction": "y",
      "on": "en"
    },
    "errors": {
      "email": "Ingrese un Dirección de correo electrónico que coincide con el formato estándar. Aquí hay un ejemplo: james.smith@example.com.",
      "emailUnavailable": "Ha ingresado una dirección de correo electrónico que ya ha sido registrada. Intente iniciar sesión para acceder a su información.",
      "emailInUse": "Ha ingresado una dirección de correo electrónico que ya ha sido registrada.",
      "password": "Su contraseña debe contener al menos 8 caracteres, 1 letra mayúscula y 1 número.",
      "confirmPassword": "Parece que las contraseñas que has introducido no coinciden! Verifique dos veces para asegurarse de que ambas entradas sean exactamente iguales.",
      "allNumericSCode": "No podemos encontrar una factura que coincida con ese SecureHealthCode. El SecureHealthCode se puede encontrar en la sección Pagar en línea de su factura.",
      "scodeRequired": "Ingrese el SecureHealthCode verde ubicado en la sección superior derecha de su factura debajo del logotipo de Patientco.",
      "amountRequired": "Ingrese el saldo total impreso en su factura. Le pediremos el monto de pago deseado en el siguiente paso.",
      "belowMinAmount": "Ha ingresado una factura con un monto negativo. Ingrese el saldo total impreso en su factura.",
      "unableToFindBill": "No podemos encontrar una factura que coincida con SecureHealthCode y el saldo total que ingresó. Verifique para asegurarse de que sus datos sean correctos.",
      "billThrottled": "Ha intentado encontrar una factura demasiadas veces. Por razones de seguridad, su capacidad para buscar facturas se ha desactivado durante unos minutos.",
      "unableToLogin": "La dirección de correo electrónico o la contraseña que ingresó es incorrecta.",
      "loginThrottled": "Ha intentado iniciar sesión muchas veces. Por razones de seguridad, su capacidad de inicio de sesión se ha inhabilitado por unos minutos",
      "loginEmailRequired": "Ingrese una dirección de correo electrónico para ayudarnos a encontrar su cuenta",
      "loginPasswordRequired": "Ingrese la contraseña de su cuenta para iniciar sesión en Patientco.",
      "minAmountArg": "Su pago el monto debe ser mayor que {{minAmount}}",
      "maxAmountArg": "El monto de su pago debe ser menor o igual al saldo de su cuenta de {{maxAmount}}",
      "dateRequired": "Seleccione una fecha del calendario.",
      "ccRequired": "Ingrese un crédito o número de tarjeta de débito.",
      "ccSeemsInvalid": "Por favor, ingrese una válida número de tarjeta. Es posible que falten números o que estén fuera de orden en su entrada actual.",
      "ccShortInvalid": "Por favor, introduzca un número de tarjeta válido.",
      "ccUnknownCardType": "Ha ingresado un tipo de tarjeta que no es aceptado. Intente usar una tarjeta Visa, Mastercard, Discover o American Express.",
      "ccExpired": "Según la fecha que ingresó, su tarjeta ha caducado y no se puede cargar.",
      "ccPrematureExpiration": "Ha ingresado una tarjeta que caduca antes de su fecha de pago. Utilice una tarjeta que caduque después de {{payMonth}} / {{payYear}}.",
      "ccIsExpired": "Esta tarjeta ha caducado.",
      "ccExpirationInvalid": "La fecha de caducidad no es válida.",
      "ccInvalidLength": "Debe ser un número de {{validLength}} dígitos.",
      "genericRequired": "Complete este campo para continuar.",
      "fieldRequired": "Este campo es requerido.",
      "genericCheckboxRequired": "Lea la exención de responsabilidad y marque esta casilla para continuar.",
      "guestPayNotAvailable": "El pago de invitados no está disponible actualmente. Por favor haga una cuenta para proceder.",
      "invalidRoutingNumber": "El número de ruta que No se ha introducido",
      "minimumAccountNumber": "Los números de cuenta deben tener al menos 4 dígitos.",
      "mismatchedAccountNumber": "Los números de cuenta deben coincidir.",
      "unableToReset": "No podemos restablecer su contraseña. Asegúrese de estar utilizando el enlace de Recuperar contraseña más reciente en su correo electrónico.",
      "paymentProcessingError": "No podemos procesar su pago. Comuníquese con Patientco al 1-844-422-4779 para completar su pago.",
      "paymentProcessingErrorApplePay": "No podemos procesar su pago. Edite su método de pago y vuelva a intentarlo.",
      "paymentInvalidCardInformation": "La información de la tarjeta que ingresó no es válida. Revise el número de tarjeta y el vencimiento de su método de pago.",
      "paymentCardDeclined": "No podemos procesar su pago debido a una tarjeta rechazada. Edite su método de pago y vuelva a intentarlo.",
      "paymentDuplicatePayment": "Parece que está intentando enviar un pago duplicado. Si esto es intencional, comuníquese con Patientco al 1-844-422-4779.",
      "confirmExpiredCard": "Parece que está intentando pagar con una tarjeta que ha caducado o que vencerá antes de la fecha de pago programada. Edite su método de pago y vuelva a intentarlo.",
      "confirmPrematureExpiration": "Parece que está intentando programar un pago después de que caduque su tarjeta de crédito. Edite su método de pago y vuelva a intentarlo.",
      "phoneFormat": "Parece que le faltan algunos números en su número de teléfono. Ingrese un número que coincida con el formato XXX-XXX-XXXX",
      "smsEligible": "Este número no es elegible para recibir mensajes de texto. Por favor ingrese un número de teléfono móvil válido en los Estados Unidos. Si no tiene un número de teléfono móvil, déjelo en blanco.",
      "termsAcceptanceRequired": "Por motivos legales, requerimos que todos los usuarios acepten nuestros Términos de uso.",
      "invalidPassword": "La contraseña actual que proporcionó no coincide con el valor que tenemos en nuestro sistema . Por favor, compruébelo y vuelva a intentarlo.",
      "unableToChangePassword": "No podemos actualizar su contraseña en este momento. Verifique sus detalles y vuelva a intentarlo.",
      "nonexistentEmail": "No hay una cuenta asociada con este correo electrónico.",
      "minZipCode": "Ingrese un código postal de 5 dígitos para continuar.",
      "fiveHundred": "Parece que el servidor encontró un error al procesar su solicitud. Inténtelo de nuevo en unos minutos.",
      "runningOutOfCharacters": "Ha usado {{current}} / {{allowed}} caracteres",
      "reasonRequired": "Seleccione el motivo del mensaje",
      "messageRequired": "Ingrese su mensaje para continuar",
      "futureBirthdate": "Ha ingresado un DOB que tendrá lugar en el futuro.",
      "incompleteBirthdate": "Ingrese un DOB completo (MM / DD / YYYY).",
      "invalidDate": "La fecha no existe.",
      "adultRequired": "Debes tener al menos 18 años de edad para continuar.",
      "unknown": "Se produjo un error desconocido. Inténtalo de nuevo. Si continúa teniendo problemas, comuníquese con Patientco al 1-844-422-4779.",
      "paymentFormProcessingError": "No podemos agregar su método de pago. Comuníquese con Patientco al 1-844-422-4779.",
      "paymentFormInvalidCardInformation": "La información de su tarjeta parece no ser válida. Revise el número de tarjeta y el vencimiento de su método de pago.",
      "ssnFormat": "Parece que le faltan algunos números en su número de seguro social. Ingrese un número que coincida con el formato XXX-XX-XXXX",
      "poBoxNotAllowed": "No permitimos apartados de correos en este momento.",
      "goToVendorErrorMessage": "Se produjo un error al intentar llevarte a {{financedBy}}.",
      "tooManyFiles": "Has adjuntado demasiados archivos. Adjunte 3 o menos archivos.",
      "genericFileError": "Se produjo un error al cargar su archivo adjunto. Inténtalo de nuevo.",
      "fileTooLarge": "Uno de los archivos que ha adjuntado es demasiado grande. Adjunte un archivo de menos de 10Mb.",
      "invalidFileType": "Adjuntó un archivo con un tipo no válido. Adjunte solo archivos jpg, jpeg, png, gif, pdf, doc, docx o txt.",
      "messageRequiredForAttachments": "Agregue un mensaje para enviar archivos adjuntos.",
      "minimumCVV": "CVV debe tener al menos 3 dígitos",
      "invalidCVV": "El CVV no es válido.",
      "paymentAgreementAcceptanceRequired": "Se requiere aceptar los términos del acuerdo de pago para continuar."
    },
    "accountEvents": {
      "bill": "Bill Sent",
      "collection": "collection",
      "collection-stop": "collection-stop",
      "collection-update": "collection-update",
      "collection-extraction": "collection-extract",
      "correspondence": "Correspondence Received",
      "correspondenceOnly": "correspondenceOnly",
      "message": "Mensaje enviado: {{message}}",
      "changeOfAddress": "Cambio de dirección",
      "payment": "Pago realizado",
      "paymentPlan": "Pago programado",
      "returnMail": "Correo devuelto",
      "reversePayment": "Reembolso procesado",
      "balanceUpdate": "Saldo actualizado",
      "voidedPayment": "Pago anulado",
      "declinedPayment": "Pago Rechazado",
      "canceledPayment": "Pago cancelado",
      "voidedPaymentPlan": "Plan de pago anulado",
      "canceledPaymentPlan": "Plan de pago cancelado"
    },
    "transworld": {
      "clientRefNum": "Número de referencia del cliente",
      "clientRefNumRequired": "Ingrese el Número de referencia del cliente en la parte superior derecha de su factura",
      "allNumericlientRefNum": "Intente ingresar la Referencia del cliente # impreso en su factura. Se encuentra en la sección superior derecha de su factura"
    },
    "fullPageNotifications": {
      "header": {
        "thankYou": "¡Gracias!"
      },
      "subheader": {
        "emailVerified": "Su dirección de correo electrónico ha sido verificada.",
        "phoneVerified": "Su número de teléfono ha sido verificado."
      },
      "message": {
        "welcome": "¡Nos complace tenerlo aquí! Se unió a una comunidad de 2 millones de consumidores que están tomando el control de sus gastos de atención médica.",
        "welcomeBranded": "¡Nos complace tenerlo aquí!"
      }
    },
    "whitelabel": {
      "landing": {
        "title": "PatientWallet | Pague su factura",
        "marketingBlurb": "Bienvenido a su PatientWallet<sup>&reg;</sup>. Administre las facturas de su familia en un solo lugar y acceda a opciones de pago flexibles que se ajustan a su presupuesto."
      },
      "dialogs": {
        "thanksAndComeBack": "¡Esperamos volver a recibirlo!",
        "welcome": "Bienvenido a tu PatientWallet<sup>&reg;</sup>"
      },
      "contact": {
        "help": {
          "lostBill": "Perdí mi factura"
        },
        "lostBill": {
          "header": "Vamos a ayudarlo a encontrar su factura.",
          "reachOut": "Comuníquese con nosotros directamente al"
        }
      },
      "confirmPhone": {
        "explanation": "Recibirá un mensaje de texto con un código único para verificar su número de teléfono móvil.",
        "additionalInfo": "Al verificar su número de teléfono, usted acepta que Patientco le envíe mensajes de texto periódicos en nombre de su proveedor para cualquier actividad relacionada con la cuenta. Patientco puede usar un sistema automatizado para enviarle comunicaciones electrónicas, incluyendo texto, teléfono o correo electrónico. Patientco no tiene un cargo separado para este servicio; sin embargo, sujeto a los términos y condiciones de su operador de telefonía móvil, pueden aplicarse tarifas de mensajes y datos. Al dar su consentimiento para participar en este programa, usted aprueba dichos cargos de su proveedor de telefonía móvil. Puede optar por no participar en este programa en cualquier momento enviando un correo electrónico a Patientco a support@patientco.com. "
      },
      "errors": {
        "scodeRequired": "Ingrese el SecureHealthCode ubicado en la sección superior derecha de su factura.",
        "loginPasswordRequired": "Ingrese la contraseña de su cuenta para iniciar sesión en PatientWallet."
      }
    },
    "verification": {
      "headerText": "Verificar correo electrónico",
      "submitButtonText": "Verificar",
      "submittingButtonText": "Verificando...",
      "explanation": "Para mejorar la seguridad, necesitamos que verifique su dirección de correo electrónico. Acabamos de enviar un código de verificación a <strong class=\"fs-block\">{{email}}</strong>. Verifique su correo electrónico e ingrese el código de 6 dígitos a continuación.",
      "emailNotSent": "No pudimos enviar el correo electrónico de verificación. Inténtalo de nuevo.",
      "successHeader": "Verificado!",
      "successSubheader": "Ha verificado con éxito su dirección de correo electrónico y ha creado su PatientWallet<sup>&reg;</sup>.",
      "emailSent": "El código ha sido enviado.",
      "codeInvalid": "Ese código fue inválido o expiró. Inténtalo de nuevo.",
      "bruteForce": "Cuenta deshabilitada temporalmente debido a demasiados intentos fallidos."
    },
    "branding": {
      "redirectingModalText": "Ahora está siendo redirigido a su <span class='provider-group-name'></span> PatientWallet<sup>&reg;</sup>",
      "redirectErrorMessage": "Se produjo un error al intentar redirigirlo a su <span class='provider-group-name'></span> PatientWallet<sup>&reg;</sup>. Vuelva a intentarlo y, si continúa teniendo problemas, comuníquese con su proveedor."
    },
    "messages": {
      "virusScan": {
        "pending": "Analizando en busca de virus...",
        "infected": "No puede descargar este archivo adjunto porque falló un análisis automático de virus."
      }
    },
    "myChartSSO": {
      "error": {
        "backToMyChart": "Regresar a MyChart",
        "body": "Por favor regrese a MyChart e intente nuevamente",
        "invalidToken": "Su sesión ha caducado",
        "header": "¡Uy! Algo salió mal"
      },
      "welcomeToPatientWallet": "Bienvenido a PatientWallet de {{ providerGroupName }}",
      "checkForPatientWalletAccount": "Buscar",
      "checkForPatientWalletAccountPending": "Buscando ...",
      "patientWalletDescription": "El PatientWallet es donde podrá acceder a todas sus facturas y realizar pagos.<br/><br/>Verifiquemos si ya tiene una cuenta.",
      "enterEmail": "Ingrese su dirección de correo electrónico",
      "emailAlreadyLinked": "Este correo electrónico ya se ha vinculado a otra cuenta de MyChart.",
      "verifyEmail": {
        "useDifferentEmail": "Usa un correo electrónico diferente",
        "foundMatch": {
          "header": "Verificar correo electrónico",
          "prompt": "¡Encontramos una coincidencia! Acabamos de enviar un código de verificación a:<br/><br/><b>{{ email }}</b><br/><br/>Verifique su correo electrónico e ingrese el código de 6 dígitos a continuación.",
          "success": {
            "header": "¡Verificado!",
            "prompt": "Ahora puede acceder a su PatientWallet directamente a través de MyChart."
          }
        },
        "noMatch": {
          "header": "Configura tu PatientWallet",
          "prompt": "Parece que todavía no tiene un PatientWallet. Está bien, podemos configurar uno para usted. Acabamos de enviar un código a:<br/><br/><b>{{ email }}</b><br/><br/>Verifique su correo electrónico e ingrese el código de 6 dígitos a continuación.",
          "success": {
            "header": "Estás listo!",
            "prompt": "Ahora tiene una nueva cuenta de PatientWallet a la que puede acceder directamente a través de MyChart."
          }
        },
        "action": "Verificar",
        "actionPending": "Verificando...",
        "resend": "Reenviar"
      },
      "finishRegistration": {
        "header": "¡Dar una buena acogida!",
        "prompt": "Parece que ha accedido a su PatientWallet antes a través de MyChart. Termine de configurar su cuenta agregando su número de teléfono y una contraseña.",
        "action": "Salvar",
        "success": {
          "header": "¡Éxito!",
          "prompt": "Tu cuenta ha sido actualizada."
        }
      }
    },
    "hiddenHeaders": {
      "providers": "Proveedores",
      "newBill": "Nueva Factura",
      "accounts": "Cuentas",
      "messages": "Mensajes",
      "inputMessage": "Ingrese un Mensaje",
      "paymentOptions": "Opciones de Pago",
      "paymentStage": "Etapa de Pago"
    },
    "breadCrumbs": {
      "providers": "Proveedores",
      "accounts": "Cuentas"
    }
  });
}]);